async function descargarCSVFacturas() {
    try {
        BO_AUTH.showAlert('Generando CSV detallado, un momento...', 'info');

        // ── 1. Solicitudes de factura ──────────────────────────────────
        const sqlFacturas = `
            SELECT f.id, f.numero_nota, f.estado, f.cfdi_id, f.cfdi_uuid,
                   f.rfc, f.razon_social, f.cp, f.regimen, f.uso_cfdi, f.forma_pago,
                   f.creado_en, f.moneda, f.tipo_cambio,
                   c.nombre, c.ape_p AS apellido, c.registro AS lider_registro
            FROM facturas_solicitadas f
            LEFT JOIN cliente c ON f.usuario_id::text = c.id::text
            ORDER BY f.id DESC`;
        const dataF = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: sqlFacturas });
        const facturas = dataF.rows || (Array.isArray(dataF) ? dataF : []);
        if (!facturas.length) { BO_AUTH.showAlert('Sin solicitudes registradas', 'warning'); return; }

        // ── 2. Clasificar notas por tipo ───────────────────────────────
        // Tipo A: UUID directo               → v.id = nota
        // Tipo B: GLOBAL-YYYY-MM-DD_YYYY-MM-DD-C{cedis}
        // Tipo C: CENTRO-{id}-YYYY-MM
        const RE_GLOBAL = /^GLOBAL-(\d{4}-\d{2}-\d{2})_(\d{4}-\d{2}-\d{2})-C(\w+)$/;
        const RE_CENTRO = /^CENTRO-(\d+)-(\d{4}-\d{2})$/;
        const RE_UUID   = /^[0-9a-f]{8}-[0-9a-f]{4}-/i;

        const uuids = [], globals = [], centros = [];
        facturas.forEach(f => {
            const n = f.numero_nota || '';
            if (RE_UUID.test(n))        uuids.push(n);
            else if (RE_GLOBAL.test(n)) globals.push(n);
            else if (RE_CENTRO.test(n)) centros.push(n);
        });

        // Fragmentos SQL reutilizables para expandir piezas JSONB
        const piezasSelect = `
            pieza->>'sku'                          AS prod_sku,
            (pieza->>'cantidad')::numeric          AS prod_cantidad,
            (pieza->>'precio_unitario')::numeric   AS prod_precio_unitario,
            COALESCE(p.nombre, pieza->>'sku')      AS prod_nombre`;
        const piezasFrom = `
            jsonb_array_elements(CASE WHEN jsonb_typeof(v.piezas)='array' THEN v.piezas ELSE '[]'::jsonb END) AS pieza
            LEFT JOIN productos p ON p.id::text = (pieza->>'producto_id')`;

        // ventaMap[nota_id] = [{prod_sku, prod_cantidad, prod_precio_unitario, prod_nombre, total, fecha_venta, moneda}]
        const ventaMap = {};
        const addRows = (rows, keyFn) => rows.forEach(r => {
            const k = keyFn(r);
            if (!ventaMap[k]) ventaMap[k] = [];
            ventaMap[k].push(r);
        });

        // ── 3A. UUID directos ──────────────────────────────────────────
        if (uuids.length) {
            const inList = uuids.map(u => `'${u}'`).join(',');
            const sql = `SELECT v.id AS venta_id, v.total, v.monto_facturable, v.fecha_venta, v.moneda, ${piezasSelect}
                         FROM venta v, ${piezasFrom}
                         WHERE v.id IN (${inList}) ORDER BY v.id, prod_sku`;
            const r = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql });
            addRows(r.rows || [], row => row.venta_id);
        }

        // ── 3B. GLOBAL (agrupadas por cedis + rango de fechas) ─────────
        for (const nota of globals) {
            const m = RE_GLOBAL.exec(nota);
            if (!m) continue;
            const [, fDesde, fHasta, cedis] = m;
            const sql = `SELECT v.total, v.monto_facturable, v.fecha_venta, v.moneda, ${piezasSelect}
                         FROM venta v, ${piezasFrom}
                         WHERE v.cedis_id::text = '${cedis}'
                           AND v.fecha_venta BETWEEN '${fDesde}' AND '${fHasta}'
                           AND v.approved = 1
                           AND v.centro_apoyo_id IS NULL
                         ORDER BY v.fecha_venta, prod_sku`;
            const r = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql });
            addRows(r.rows || [], () => nota);
        }

        // ── 3C. CENTRO (agrupadas por centro_apoyo_id + mes) ──────────
        for (const nota of centros) {
            const m = RE_CENTRO.exec(nota);
            if (!m) continue;
            const [, centroId, mes] = m;
            const sql = `SELECT v.total, v.monto_facturable, v.fecha_venta, v.moneda, ${piezasSelect}
                         FROM venta v, ${piezasFrom}
                         WHERE v.centro_apoyo_id = ${centroId}
                           AND to_char(v.fecha_venta,'YYYY-MM') = '${mes}'
                           AND v.approved = 1
                         ORDER BY v.fecha_venta, prod_sku`;
            const r = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql });
            addRows(r.rows || [], () => nota);
        }

        // ── 4. Construir CSV ───────────────────────────────────────────
        const esc = v => `"${String(v||'').replace(/"/g,"'")}"`;
        const headers = [
            'Nota_ID','Factura_ID','Lider','Registro_Lider','RFC','Razon_Social',
            'CP','Regimen','Uso_CFDI','Forma_Pago',
            'SKU_Producto','Nombre_Producto','Cantidad_Piezas','Precio_Unitario','Subtotal_Producto',
            'Total_Venta','Monto_Facturable','Moneda','Tipo_Cambio',
            'Estado_CFDI','CFDI_ID','CFDI_UUID','Fecha_Solicitud','Fecha_Venta'
        ];
        const csvRows = ['\uFEFF' + headers.join(',')]; // BOM para Excel en español

        facturas.forEach(f => {
            const notaId   = f.numero_nota || '';
            const piezas   = ventaMap[notaId] || [];
            const lider    = `${f.nombre||''} ${f.apellido||''}`.trim();
            const fechaSol = f.creado_en ? new Date(f.creado_en).toLocaleDateString('es-MX') : '';

            if (!piezas.length) {
                // Nota sin ventas encontradas en BD
                csvRows.push([
                    esc(notaId), f.id, esc(lider), f.lider_registro||'',
                    f.rfc||'', esc(f.razon_social), f.cp||'', esc(f.regimen),
                    f.uso_cfdi||'', f.forma_pago||'',
                    '(sin ventas registradas)','','','','',
                    '','', f.moneda||'MXN', f.tipo_cambio||1,
                    f.estado||'', f.cfdi_id||'', f.cfdi_uuid||'', fechaSol, ''
                ].join(','));
            } else {
                piezas.forEach(pz => {
                    const subtotal   = (+(pz.prod_cantidad||0) * +(pz.prod_precio_unitario||0)).toFixed(2);
                    const fechaVenta = pz.fecha_venta ? new Date(pz.fecha_venta).toLocaleDateString('es-MX') : '';
                    csvRows.push([
                        esc(notaId), f.id, esc(lider), f.lider_registro||'',
                        f.rfc||'', esc(f.razon_social), f.cp||'', esc(f.regimen),
                        f.uso_cfdi||'', f.forma_pago||'',
                        pz.prod_sku||'', esc(pz.prod_nombre), pz.prod_cantidad||0, pz.prod_precio_unitario||0, subtotal,
                        pz.total||'', pz.monto_facturable||'', pz.moneda||f.moneda||'MXN', f.tipo_cambio||1,
                        f.estado||'', f.cfdi_id||'', f.cfdi_uuid||'', fechaSol, fechaVenta
                    ].join(','));
                });
            }
        });

        // ── 5. Descarga ────────────────────────────────────────────────
        const mes   = document.getElementById('cfdi-mes')?.value || '';
        const anio  = document.getElementById('cfdi-anio')?.value || new Date().getFullYear();
        const fname = `facturas_desglose_${mes}_${anio}.csv`;
        const blob  = new Blob([csvRows.join('\n')], { type: 'text/csv;charset=utf-8' });
        const url   = window.URL.createObjectURL(blob);
        const a     = document.createElement('a');
        a.setAttribute('href', url);
        a.setAttribute('download', fname);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        BO_AUTH.showAlert(`CSV generado: ${csvRows.length - 1} líneas de detalle`, 'success');
    } catch(e) {
        BO_AUTH.showAlert('Error generando CSV: ' + e.message, 'error');
        console.error(e);
    }
}

// ── Premios Especiales ───────────────────────────────────────────────────────
async function asignarPremioEspecial() {
    const userId = parseInt(document.getElementById('pe-userId')?.value);
    const nombre = document.getElementById('pe-nombre')?.value?.trim();
    const icono  = document.getElementById('pe-icono')?.value || '🏆';
    const desc   = document.getElementById('pe-desc')?.value?.trim() || '';
    const fecha  = document.getElementById('pe-fecha')?.value;
    if (!userId || !nombre) { BO_AUTH.showAlert('Completa ID del Líder y Nombre del Premio', 'warning'); return; }
    try {
        // Validation & UUID resolution
        const _sqlCheck = `SELECT id FROM cliente WHERE id::text='${userId}' OR registro::text='${userId}'`;
        const chk = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: _sqlCheck });
        const row = Array.isArray(chk) ? chk[0] : (chk?.rows?.[0]);
        if (!row) { BO_AUTH.showAlert('El Líder especificado no está registrado en la base de datos oficial.', 'error'); return; }

        // Drop FK collision dynamically
        try { await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: `ALTER TABLE notificaciones DROP CONSTRAINT IF EXISTS notif_user_fk CASCADE;` }); } catch(e){}

        await BO_API.asignarPremio({
            liderId: row.id,
            categoria: `${icono} ${nombre}`,
            descripcion: desc,
            asignadoPor: CURRENT_USER.id,
            fecha: fecha
        });

        // Notificación oficial in-app al líder (para su campanita / pestaña Galardones)
        try {
            const titNotif = `🏆 ¡Premio Concedido: ${icono} ${nombre}!`;
            const msgNotif = `La Dirección de Dulet te ha otorgado un reconocimiento especial: ${icono} ${nombre}.${desc ? ' Detalle: ' + desc : ''} ¡Enhorabuena por tu extraordinario trabajo en tu cadena!`;
            await BO_API.post('/bo/sql-relay', {
                secret: 'duletia_relay_2026',
                sql: `INSERT INTO notificaciones (user_id, titulo, mensaje, tipo, leida, created_at, expires_at) VALUES ('${row.id}', '${titNotif.replace(/'/g, "''")}', '${msgNotif.replace(/'/g, "''")}', 'galardon', false, NOW(), NOW() + INTERVAL '90 days')`
            });
            if (typeof loadNotificaciones === 'function') loadNotificaciones();
        } catch(eNotif) { console.warn('Error al notificar premio especial:', eNotif); }

        BO_AUTH.showAlert(`✓ Premio "${icono} ${nombre}" asignado al líder #${userId}`, 'success');
        document.getElementById('pe-userId').value = '';
        document.getElementById('pe-nombre').value = '';
        document.getElementById('pe-desc').value = '';
        loadPremiosEspeciales(userId);
    } catch(e) {
        BO_AUTH.showAlert('Error asignando premio: ' + e.message, 'error');
    }
}

let _peItems = [];
let _pePage = 1;

async function loadPremiosEspeciales(userId) {
    const cont = document.getElementById('premiosEspecialesHistorial'); if (!cont) return;
    try {
        // Remove userId para cargar los de TODOS si está vacío
        const rs = await BO_API.getPremios(userId || '');
        console.log('[PREMIOS] Raw response:', JSON.stringify(rs));
        _peItems = Array.isArray(rs) ? rs : (rs?.rows || rs?.data || []);
        console.log('[PREMIOS] Parsed items count:', _peItems.length, 'first:', _peItems[0]);
        _pePage = 1;
        renderPePaginated();
    } catch(e) { 
        console.error('[PREMIOS] Error:', e.message);
        cont.innerHTML = '<div style="color:var(--danger)">Error al cargar premios: '+e.message+'</div>'; 
    }
}

function peChangePage(dir) {
    const maxP = Math.ceil(_peItems.length / 25);
    _pePage += dir;
    if(_pePage < 1) _pePage = 1;
    if(_pePage > maxP) _pePage = maxP;
    renderPePaginated();
}

function renderPePaginated() {
    const cont = document.getElementById('premiosEspecialesHistorial');
    const info = document.getElementById('pe-page-info');
    const prev = document.getElementById('pe-prev');
    const next = document.getElementById('pe-next');
    if(!cont) return;

    if (!_peItems.length) { 
        cont.innerHTML = '<div style="color:var(--text-dim)">Sin premios asignados aún en la base de datos.</div>'; 
        if(info) info.textContent = `Página 1`;
        if(prev) prev.disabled = true;
        if(next) next.disabled = true;
        return; 
    }

    const maxP = Math.ceil(_peItems.length / 25);
    if(info) info.textContent = `Página ${_pePage} de ${maxP}`;
    if(prev) prev.disabled = (_pePage === 1);
    if(next) next.disabled = (_pePage === maxP);

    const start = (_pePage - 1) * 25;
    const pageItems = _peItems.slice(start, start + 25);
    
    cont.innerHTML = pageItems.map(p => `
    <div style="display:flex;align-items:center;justify-content:space-between;padding:.5rem 0;border-bottom:1px solid var(--border-dark)">
        <div style="display:flex;align-items:center;gap:.75rem;">
            <span class="badge" style="background:var(--card-bg);border:1px solid var(--border-light);font-size:1.5rem;padding:.2rem .4rem">${(p.categoria || p.nombre || '🏆').charAt(0) === '🏆' || (p.categoria || '').match(/^[\u{1F300}-\u{1FAFF}]/u) ? (p.categoria || p.nombre || '🏆').split(' ')[0] : '🏆'}</span>
            <div>
                 <div style="font-weight:600;color:var(--text-primary)">${p.categoria || p.nombre || 'Premio'}</div>
                <div style="font-size:.72rem;color:var(--text-dim)">Líder: ${p.lider_nombre ? p.lider_nombre + ' (#' + (p.lider_registro || p.lider_id || '') + ')' : (p.winner_nombre ? p.winner_nombre + ' (#' + p.winner_registro + ')' : (p.lider_id || p.user_id || 'N/A'))} · ${(p.fecha_asignacion || p.fecha) ? new Date(p.fecha_asignacion || p.fecha).toISOString().split('T')[0] : ''} · Asignado por: ${(p.asignado_por_nombre || '').trim() || (p.asignado_por || '').trim() || 'Sistema'}</div>
                 ${p.descripcion ? `<div style="font-size:0.75rem;color:var(--text-dim)">${p.descripcion}</div>` : ''}
            </div>
        </div>
        <button class="btn btn-sm" style="background:transparent;color:var(--danger);padding:0 .5rem;" onclick="eliminarPremio(${p.id})">🗑️ Quitar</button>
    </div>`).join('');
}

async function asignarGalardon() {
    const userId = parseInt(document.getElementById('gal-user-id')?.value);
    const galipo = document.getElementById('gal-tipo')?.value;
    const fecha = document.getElementById('gal-fecha')?.value;
    if (!userId || !galipo) { BO_AUTH.showAlert('Ingresa ID y Galardón', 'warning'); return; }
    
    try {
        // Validation & UUID resolution
        const _sqlCheck = `SELECT id FROM cliente WHERE id::text='${userId}' OR registro::text='${userId}'`;
        const chk = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: _sqlCheck });
        const row = Array.isArray(chk) ? chk[0] : (chk?.rows?.[0]);
        if (!row) { BO_AUTH.showAlert('Este Líder no existe en el sistema oficial.', 'error'); return; }

        // Drop FK collision dynamically
        try { await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: `ALTER TABLE notificaciones DROP CONSTRAINT IF EXISTS notif_user_fk CASCADE;` }); } catch(e){}

        const lbl = document.getElementById('gal-tipo').options[document.getElementById('gal-tipo').selectedIndex].text;
        
        // 1. Asignar el premio al historial usando los campos correctos del workflow
        await BO_API.asignarPremio({
            liderId: row.id,
            categoria: `🏅 Galardón: ${lbl}`,
            descripcion: `Ascenso a ${lbl}`,
            asignadoPor: CURRENT_USER.id,
            fecha: fecha
        });

        // 2. Actualizar el perfil del usuario DIRECTAMENTE VIA DDBB PARA NO ROMPER ENDPOINT
        await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: `UPDATE cliente SET galardon='${galipo}' WHERE id::text='${row.id}'` });

        // 3. Notificación oficial in-app al líder (para su campanita / pestaña Galardones)
        try {
            const titNotif = `🏆 ¡Felicidades! Has sido galardonado como ${lbl}`;
            const msgNotif = `La Dirección General de Dulet reconoce tu constancia, liderazgo e impacto en tu cadena. Tu reconocimiento oficial y los beneficios de ${lbl} ya están activos en tu perfil. ¡Gracias por hacer crecer a la Gran Familia Dulet!`;
            await BO_API.post('/bo/sql-relay', {
                secret: 'duletia_relay_2026',
                sql: `INSERT INTO notificaciones (user_id, titulo, mensaje, tipo, leida, created_at, expires_at) VALUES ('${row.id}', '${titNotif.replace(/'/g, "''")}', '${msgNotif.replace(/'/g, "''")}', 'galardon', false, NOW(), NOW() + INTERVAL '90 days')`
            });
            if (typeof loadNotificaciones === 'function') loadNotificaciones();
        } catch(eNotif) { console.warn('Error al notificar galardón:', eNotif); }
        
        BO_AUTH.showAlert(`✓ ${lbl} asignado correctamente a #${userId}`, 'success');
        document.getElementById('gal-user-id').value = '';
        loadPremiosEspeciales();
    } catch(e) {
        BO_AUTH.showAlert('Error asignando galardón: ' + e.message, 'error');
    }
}

async function eliminarPremio(id) {
    if (!confirm('¿Estás seguro que deseas eliminar/revocar este premio del historial?')) return;
    try {
        await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: `DELETE FROM premios_especiales WHERE id=${id}`});
        BO_AUTH.showAlert('Premio eliminado exitosamente.', 'success');
        loadPremiosEspeciales();
    } catch(e) {
        BO_AUTH.showAlert('Error cancelando premio: ' + e.message, 'error');
    }
}

async function activarPromoOculta() {
    const userId = document.getElementById('promo-userId')?.value || '';
    const pais   = document.getElementById('promo-pais')?.value;
    const estado = document.getElementById('promo-estado')?.value || '';
    const titulo = document.getElementById('promo-titulo')?.value || '';
    const desc   = document.getElementById('promo-mensaje')?.value || '';
    const img    = document.getElementById('promo-imagen')?.value || '';
    
    if(!titulo || !desc) { BO_AUTH.showAlert('El Título y el Mensaje son obligatorios', 'warning'); return; }
    
    // Mostramos estado en el preview
    const res = document.getElementById('promo-resultado');
    if(res) {
        res.innerHTML = `<span style="color:var(--text-dim)">Segmentando y enviando notificaciones...</span>`;
    }
    
    try {
        const result = await BO_API.post('/bo/promos/activar', { userId, pais, estado, titulo, desc, img });
        const total = result.total || 0;
        if (total === 0) {
            BO_AUTH.showAlert(`⚠ No se encontró ningún líder con ese filtro. Verifica el ID o país.`, 'warning');
            if(res) res.innerHTML = `<span style="color:var(--warning)">⚠ 0 líderes encontrados. La promo no fue enviada a nadie.</span>`;
        } else {
            BO_AUTH.showAlert(`🎁 Promo enviada a ${total} líder(es) exitosamente`, 'success');
            if(res) {
                res.innerHTML = `<span style="color:var(--success)">✅ Promo "${titulo}" enviada a ${total} líder(es) ${userId ? '(ID: '+userId+')' : ''} ${pais ? 'en '+pais : ''}. Expira en 24h. La promo aparece en SU centro de notificaciones.</span>`;
            }
        }
        document.getElementById('promo-titulo').value = '';
        document.getElementById('promo-mensaje').value = '';
        document.getElementById('promo-imagen').value = '';
    } catch(e) {
        BO_AUTH.showAlert('Error enviando promo: ' + e.message, 'error');
        if(res) res.innerHTML = `<span style="color:var(--danger)">Error: ${e.message}</span>`;
    }
}
// ── Aviso de Sistema ─────────────────────────────────────────────────────────
async function enviarAvisoSistema() {
    const titulo  = document.getElementById('sist-titulo')?.value?.trim();
    const mensaje = document.getElementById('sist-mensaje')?.value?.trim();
    const res     = document.getElementById('sist-resultado');
    if (!titulo || !mensaje) { BO_AUTH.showAlert('Título y Mensaje son obligatorios', 'warning'); return; }
    if (res) res.innerHTML = `<span style="color:var(--text-dim)">📡 Enviando aviso a todos los usuarios...</span>`;
    try {
        const result = await BO_API.post('/bo/notificaciones/sistema', { titulo, mensaje });
        const total = result.total || 0;
        if (total === 0) {
            BO_AUTH.showAlert('⚠ No se enviaron avisos. Verifica que haya usuarios activos.', 'warning');
            if (res) res.innerHTML = `<span style="color:var(--warning)">⚠ Sin usuarios activos encontrados.</span>`;
        } else {
            BO_AUTH.showAlert(`📢 Aviso enviado a ${total} usuario(s) exitosamente`, 'success');
            if (res) res.innerHTML = `<span style="color:var(--success)">✅ Aviso "${titulo}" enviado a ${total} usuario(s). Expira al cambiar de mes.</span>`;
            document.getElementById('sist-titulo').value = '';
            document.getElementById('sist-mensaje').value = '';
        }
    } catch(e) {
        BO_AUTH.showAlert('Error enviando aviso: ' + e.message, 'error');
        if (res) res.innerHTML = `<span style="color:var(--danger)">Error: ${e.message}</span>`;
    }
}

// ── Lanzar Alertas de Riesgo Manual ──────────────────────────────────────────
async function lanzarAlertasRiesgo() {
    const btn = document.getElementById('btnAlertasRiesgo');
    const res = document.getElementById('alertas-riesgo-resultado');
    if (btn) { btn.disabled = true; btn.textContent = '⏳ Procesando...'; }
    if (res) res.innerHTML = '';
    try {
        const result = await BO_API.post('/bo/alertas/riesgo/lanzar', {});
        const total = result.total || 0;
        if (total === 0) {
            if (res) res.innerHTML = `<span style="color:var(--text-dim)">✓ Sin líderes en riesgo esta vez.</span>`;
        } else {
            BO_AUTH.showAlert(`⚠ ${total} patrocinador(es) notificados sobre líderes en riesgo`, 'success');
            if (res) res.innerHTML = `<span style="color:var(--warning)">⚠ ${total} patrocinador(es) notificados</span>`;
        }
    } catch(e) {
        BO_AUTH.showAlert('Error lanzando alertas: ' + e.message, 'error');
        if (res) res.innerHTML = `<span style="color:var(--danger)">Error: ${e.message}</span>`;
    } finally {
        if (btn) { btn.disabled = false; btn.innerHTML = '⚠ Lanzar Alertas de Riesgo'; }
    }
}

// ── Semáforo de Actividad: cards visuales por estatus ────────────────────────
function renderSemaforoCards(lideres, stats) {
    const cont = document.getElementById('semaforoCards'); if (!cont) return;
    // Estatus dinámico
    const grupos = {
        activo:       { icon:'🟢', label:'Activo — Compró este mes',      color:'#22C55E',  count: +(stats?.cnt_activo || 0) },
        inactivo:     { icon:'⚪', label:'Inactivo — Sin compra este mes', color:'#6b7280',  count: +(stats?.cnt_inactivo || 0) },
        seguimiento:  { icon:'🟡', label:'En seguimiento — 2 meses',      color:'#F59E0B',  count: +(stats?.cnt_seguimiento || 0) },
        baja:         { icon:'🔴', label:'Baja — 3+ meses sin compra',    color:'#EF4444',  count: +(stats?.cnt_baja || 0) },
        nuevo:        { icon:'🔵', label:'Nuevo — Registrado este mes',   color:'#60A5FA',  count: +(stats?.cnt_nuevo || 0) },
    };
    const total = Object.values(grupos).reduce((a,g)=>a+g.count,0)||1;
    cont.innerHTML = Object.entries(grupos).map(([k,g]) => `
        <div style="flex:1;background:rgba(255,255,255,.04);border:1px solid var(--border-dark);border-radius:var(--radius-md);padding:.8rem .5rem;text-align:center;cursor:pointer;transition:transform .15s" onmouseover="this.style.transform='translateY(-2px)'" onmouseout="this.style.transform=''" ${k === 'nuevo' ? 'onclick="abrirModalNuevosDistribuidores()"' : ''}>
            <div style="font-size:1.5rem;margin-bottom:.2rem">${g.icon}</div>
            <div style="font-size:1.4rem;font-weight:800;color:${g.color}">${g.count.toLocaleString()}</div>
            <div style="font-size:.68rem;color:var(--text-dim);margin-top:.15rem;line-height:1.2">${g.label}</div>
            <div style="margin-top:.4rem;background:var(--border-dark);border-radius:100px;height:4px;overflow:hidden">
                <div style="height:100%;background:${g.color};width:${Math.round(g.count/total*100)}%;transition:width 1s ease"></div>
            </div>
            <div style="font-size:.65rem;color:var(--text-dim);margin-top:.2rem">${Math.round(g.count/total*100)}%</div>
        </div>`).join('');
}

// ── Modal de Nuevos Distribuidores del Mes (OnClick en tarjeta azul) ──────────
window._nuevosDistribuidoresCache = [];

async function abrirModalNuevosDistribuidores() {
    document.getElementById('modalNuevosDistribuidores')?.remove();

    const mesInput = document.getElementById('mesFiltro');
    const mesStr = mesInput?.value || new Date().toISOString().substring(0,7);

    const modal = document.createElement('div');
    modal.id = 'modalNuevosDistribuidores';
    modal.style.cssText = 'position:fixed;inset:0;z-index:9999;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,.75);backdrop-filter:blur(4px);padding:1rem';
    modal.onclick = e => { if (e.target === modal) modal.remove(); };

    modal.innerHTML = `
        <div style="background:var(--card-bg,#1a1a2e);border:1px solid rgba(96,165,250,.3);border-radius:14px;max-width:1050px;width:100%;max-height:85vh;display:flex;flex-direction:column;box-shadow:0 25px 70px rgba(0,0,0,.6);overflow:hidden">
            <div style="padding:1.2rem 1.5rem;border-bottom:1px solid rgba(63,63,70,.3);display:flex;justify-content:space-between;align-items:center;background:rgba(96,165,250,.04)">
                <div>
                    <h3 style="margin:0;font-size:1.15rem;color:#fff;display:flex;align-items:center;gap:.5rem">
                        <span>🔵</span> Nuevos Distribuidores Registrados
                    </h3>
                    <p id="mnd-subtitulo" style="margin:.25rem 0 0;font-size:.8rem;color:var(--text-dim)">
                        Consultando registros de ${mesStr}...
                    </p>
                </div>
                <button onclick="document.getElementById('modalNuevosDistribuidores').remove()" style="background:none;border:none;color:#9ca3af;font-size:1.5rem;cursor:pointer;padding:.25rem .5rem;line-height:1" onmouseover="this.style.color='#fff'" onmouseout="this.style.color='#9ca3af'">✕</button>
            </div>
            <div style="padding:.75rem 1.5rem;background:rgba(0,0,0,.15);border-bottom:1px solid rgba(63,63,70,.2);display:flex;gap:1rem;align-items:center;justify-content:space-between">
                <input id="mnd-search" type="text" placeholder="🔍 Buscar por nombre, registro, teléfono o patrocinador..." style="background:rgba(255,255,255,.06);border:1px solid rgba(63,63,70,.5);border-radius:6px;padding:.4rem .75rem;font-size:.8rem;color:#fff;flex:1;max-width:400px" onkeyup="_filtrarNuevosTabla()">
                <button id="mnd-btn-csv" class="btn btn-secondary btn-sm" style="font-size:.75rem;display:none" onclick="_exportarCsvNuevos()">📥 Exportar CSV</button>
            </div>
            <div id="mnd-body" style="padding:1rem 1.5rem;overflow-y:auto;flex:1">
                <div style="text-align:center;padding:3rem 0;color:var(--text-dim)">
                    <div class="spinner" style="margin:0 auto 1rem"></div>
                    Cargando distribuidores nuevos...
                </div>
            </div>
        </div>`;
    document.body.appendChild(modal);

    try {
        const sql = `
            SELECT c.id, c.registro, 
                   CONCAT(COALESCE(c.nombre,''),' ',COALESCE(c.ape_p,''),' ',COALESCE(c.ape_m,'')) as nombre_completo,
                   COALESCE(c.whatsapp, c.tel) as contacto,
                   c.email, c.created_at, c.patrocinador,
                   CONCAT(COALESCE(p.nombre,''),' ',COALESCE(p.ape_p,'')) as patrocinador_nombre,
                   (SELECT COUNT(v.id) FROM venta v WHERE v.cliente_id::text = c.id::text AND v.approved = 1) as compras_count
            FROM cliente c
            LEFT JOIN cliente p ON c.patrocinador::text = p.id::text OR c.patrocinador::text = p.registro::text
            WHERE TO_CHAR(c.created_at, 'YYYY-MM') = '${mesStr}'
            ORDER BY c.created_at DESC
        `;
        const res = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql });
        const rows = res?.rows || [];
        window._nuevosDistribuidoresCache = rows;
        _renderModalNuevos(rows, mesStr);
    } catch(err) {
        console.error('Error al cargar nuevos distribuidores:', err);
        const bodyEl = document.getElementById('mnd-body');
        if (bodyEl) {
            bodyEl.innerHTML = `<div style="color:var(--danger,#ef4444);padding:2rem;text-align:center">⚠ Error al consultar datos: ${err.message}</div>`;
        }
    }
}

function _renderModalNuevos(rows, mesStr) {
    const bodyEl = document.getElementById('mnd-body');
    const subEl = document.getElementById('mnd-subtitulo');
    const btnCsv = document.getElementById('mnd-btn-csv');
    if (!bodyEl) return;

    if (subEl) subEl.innerHTML = `Período: <strong>${mesStr}</strong> · <span style="color:#60a5fa;font-weight:700">${rows.length} nuevos registrados</span>`;
    if (btnCsv && rows.length > 0) btnCsv.style.display = 'inline-block';

    if (!rows.length) {
        bodyEl.innerHTML = '<div style="text-align:center;padding:2.5rem;color:var(--text-dim)">No hay distribuidores registrados este mes.</div>';
        return;
    }

    const tableRows = rows.map((r, i) => {
        const fecha = r.created_at ? new Date(r.created_at).toLocaleDateString('es-MX', {day:'2-digit', month:'short', year:'numeric', hour:'2-digit', minute:'2-digit'}) : '—';
        const primerNombre = (r.nombre_completo || '').trim().split(' ')[0] || 'Distribuidor';
        const numCompras = Number(r.compras_count || 0);
        const activado = numCompras > 0;
        const badgeActivacion = activado
            ? '<span style="background:rgba(34,197,94,.15);color:#22c55e;border:1px solid rgba(34,197,94,.3);padding:.15rem .5rem;border-radius:100px;font-size:.72rem;font-weight:600">✅ Activado (' + numCompras + ')</span>'
            : '<span style="background:rgba(245,158,11,.15);color:#f59e0b;border:1px solid rgba(245,158,11,.3);padding:.15rem .5rem;border-radius:100px;font-size:.72rem;font-weight:600">🟡 Sin 1ra compra</span>';

        let waBtn = '<span style="color:var(--text-dim);font-size:.75rem">—</span>';
        if (r.contacto) {
            let phoneClean = String(r.contacto).replace(/\D/g, '');
            if (phoneClean.length === 10) phoneClean = '52' + phoneClean;
            if (phoneClean.length >= 10) {
                const msg = `¡Hola ${primerNombre}! Te damos la más cordial bienvenida a la familia Dulet. Estamos muy contentos de tenerte en el equipo. ¿Tienes alguna duda para arrancar tu negocio?`;
                const waUrl = `https://wa.me/${phoneClean}?text=${encodeURIComponent(msg)}`;
                waBtn = `<a href="${waUrl}" target="_blank" rel="noopener noreferrer" style="display:inline-flex;align-items:center;gap:.3rem;background:#25D366;color:#fff;text-decoration:none;padding:.25rem .6rem;border-radius:6px;font-size:.75rem;font-weight:600;transition:opacity .15s" onmouseover="this.style.opacity='.85'" onmouseout="this.style.opacity='1'">
                    <span>💬</span> WhatsApp
                </a>`;
            }
        }

        return `
            <tr class="mnd-row" style="border-bottom:1px solid rgba(63,63,70,.25)">
                <td style="padding:.5rem;color:var(--text-dim);font-size:.75rem">${i+1}</td>
                <td style="padding:.5rem;font-size:.8rem;font-weight:600;color:#fff">${r.nombre_completo || '—'}</td>
                <td style="padding:.5rem;font-size:.78rem;font-family:monospace;color:var(--primary,#60a5fa)">#${r.registro || '—'}</td>
                <td style="padding:.5rem;font-size:.75rem;color:var(--text-dim);white-space:nowrap">${fecha}</td>
                <td style="padding:.5rem;font-size:.78rem">${badgeActivacion}</td>
                <td style="padding:.5rem;font-size:.78rem;color:#e2e8f0">${r.patrocinador_nombre?.trim() || r.patrocinador || '—'}</td>
                <td style="padding:.5rem;font-size:.78rem;color:var(--text-dim)">${r.contacto || r.email || '—'}</td>
                <td style="padding:.5rem;text-align:center">${waBtn}</td>
            </tr>
        `;
    }).join('');

    bodyEl.innerHTML = `
        <table style="width:100%;border-collapse:collapse">
            <thead>
                <tr style="border-bottom:2px solid rgba(63,63,70,.4);font-size:.72rem;color:var(--text-dim);text-transform:uppercase">
                    <th style="padding:.5rem;text-align:left">#</th>
                    <th style="padding:.5rem;text-align:left">Distribuidor</th>
                    <th style="padding:.5rem;text-align:left">Registro</th>
                    <th style="padding:.5rem;text-align:left">Fecha Alta</th>
                    <th style="padding:.5rem;text-align:left">Estado</th>
                    <th style="padding:.5rem;text-align:left">Patrocinador</th>
                    <th style="padding:.5rem;text-align:left">Contacto</th>
                    <th style="padding:.5rem;text-align:center">Bienvenida</th>
                </tr>
            </thead>
            <tbody id="mnd-tbody">${tableRows}</tbody>
        </table>
    `;
}

function _filtrarNuevosTabla() {
    const q = (document.getElementById('mnd-search')?.value || '').toLowerCase().trim();
    const rows = document.querySelectorAll('.mnd-row');
    rows.forEach(r => {
        const text = r.textContent.toLowerCase();
        r.style.display = (!q || text.includes(q)) ? '' : 'none';
    });
}

function _exportarCsvNuevos() {
    const data = window._nuevosDistribuidoresCache || [];
    if (!data.length) return;

    const csvEscape = val => {
        if (val === null || val === undefined) return '""';
        return `"${String(val).replace(/"/g, '""')}"`;
    };

    const headers = ['Registro', 'Nombre Completo', 'Fecha Alta', 'Activado', 'Compras', 'Patrocinador', 'Contacto', 'Email'];
    const lines = [headers.join(',')];

    data.forEach(r => {
        const f = (r.created_at || '').substring(0, 19).replace('T', ' ');
        const act = Number(r.compras_count || 0) > 0 ? 'Sí' : 'No';
        lines.push([
            csvEscape(r.registro || ''),
            csvEscape(r.nombre_completo || ''),
            csvEscape(f),
            csvEscape(act),
            Number(r.compras_count || 0),
            csvEscape(r.patrocinador_nombre || r.patrocinador || ''),
            csvEscape(r.contacto || ''),
            csvEscape(r.email || '')
        ].join(','));
    });

    const csvContent = '\uFEFF' + lines.join('\r\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `Nuevos_Distribuidores_${new Date().toISOString().substring(0,10)}.csv`;
    link.click();
}

// ══════════════════════════════════════════════════════════════
// MODO PROSPECTO / DEMO
// Activo cuando CURRENT_USER.rol === 'prospecto'
// ══════════════════════════════════════════════════════════════
const DEMO_STATS = {
    ventas_mes:    187500,
    cajas_mes:     63,
    activos_disp:  13500,
    lideres_total: 47,
    lideres_verdes:28,
    lideres_amarillos:12,
    lideres_rojos: 7,
    producto_top:  'Dulet Fresa',
    producto_top_cajas: 14,
    cedis_top:     'Cancún, Q. Roo',
    cedis_top_monto: 45000,
    ingresos_tipo: { efectivo:55000, transferencia:72000, deposito:38000, activos:22500 },
};

// Acciones de prospecto bloqueadas (piden registro)
const DEMO_BLOCKED_ACTIONS = [
    'solicitarFactura', 'solicitarFacturaFacturama', 'guardarModificacionNota',
    'asignarGalardon', 'asignarPremioEspecial', 'activarPromoOculta',
    'confirmarCancelar', 'publicarNoticia', 'agregarProducto', 'editarProducto',
    'eliminarProducto', 'eliminarPremio'
];

function activarModoProspecto() {
    // 1. Banner
    const banner = document.getElementById('demoBanner');
    if (banner) banner.style.display = 'flex';

    // 2. Mensaje de bienvenida personalizado
    const saludo = document.getElementById('dashGreeting');
    if (saludo) saludo.textContent = '👀 Estás explorando el sistema en modo vista previa — ¡Bienvenido/a!';

    // 3. Inyectar datos demo en los widgets del dashboard
    setTimeout(() => {
        const ventas  = document.getElementById('kpiVentas');
        const cajas   = document.getElementById('kpiCajas');
        const activos = document.getElementById('activoDisp');
        if (ventas)  ventas.textContent  = '$' + DEMO_STATS.ventas_mes.toLocaleString('es-MX') + ' MXN';
        if (cajas)   cajas.textContent   = DEMO_STATS.cajas_mes + ' cajas';
        if (activos) activos.textContent = '$' + DEMO_STATS.activos_disp.toLocaleString('es-MX') + ' MXN';

        // Widget tipo de pago
        const tipoPagoEl = document.getElementById('widgetTipoPago');
        if (tipoPagoEl) {
            const tp = DEMO_STATS.ingresos_tipo;
            tipoPagoEl.innerHTML = [
                ['💵 Efectivo', tp.efectivo],['🏦 Transferencia', tp.transferencia],
                ['📋 Depósito', tp.deposito],['💠 Activos', tp.activos],
            ].map(([k,v])=>`<div style="display:flex;justify-content:space-between;padding:.35rem 0;border-bottom:1px solid var(--border-dark);font-size:.82rem">
                <span style="color:var(--text-secondary)">${k}</span>
                <span style="font-weight:700;color:var(--success)">$${v.toLocaleString()}</span>
            </div>`).join('');
        }

        // Widget producto top
        const prodTopEl = document.getElementById('widgetProdTop');
        if (prodTopEl) {
            prodTopEl.innerHTML = `<div style="text-align:center;padding:.75rem 0">
                <div style="font-size:2rem">🍓</div>
                <div style="font-size:1.1rem;font-weight:800;color:var(--text-primary);margin:.25rem 0">${DEMO_STATS.producto_top}</div>
                <div style="font-size:.78rem;color:var(--text-dim)">${DEMO_STATS.producto_top_cajas} cajas este mes</div>
            </div>`;
        }

        // Semáforo cards
        renderSemaforoCards([
            ...Array(DEMO_STATS.lideres_verdes).fill({estatus:'blanca'}),
            ...Array(DEMO_STATS.lideres_amarillos).fill({estatus:'amarillo'}),
            ...Array(DEMO_STATS.lideres_rojos).fill({estatus:'rojo'}),
            ...Array(2).fill({estatus:'baja'}),
        ]);

        // Top CEDIS
        const topCedisEl = document.getElementById('widgetTopCedis');
        if (topCedisEl) {
            topCedisEl.innerHTML = `<div style="font-size:.82rem">
                <div style="display:flex;justify-content:space-between;padding:.4rem 0;border-bottom:1px solid var(--border-dark)">
                    <span>🏆 ${DEMO_STATS.cedis_top}</span>
                    <span style="font-weight:700;color:var(--success)">$${DEMO_STATS.cedis_top_monto.toLocaleString()}</span>
                </div>
                <div style="display:flex;justify-content:space-between;padding:.4rem 0;border-bottom:1px solid var(--border-dark)">
                    <span>🥈 Guadalajara, Jal.</span>
                    <span style="font-weight:700;color:var(--success)">$38,200</span>
                </div>
                <div style="display:flex;justify-content:space-between;padding:.4rem 0">
                    <span>🥉 Ciudad de México</span>
                    <span style="font-weight:700;color:var(--success)">$29,500</span>
                </div>
            </div>`;
        }
    }, 600);

    // 4. Interceptar acciones bloqueadas
    DEMO_BLOCKED_ACTIONS.forEach(fn => {
        if (typeof window[fn] === 'function') {
            window['_orig_' + fn] = window[fn];
            window[fn] = function() {
                mostrarMensajeDemo();
            };
        }
    });

    // 5. Sidebar — ocultar acciones admin
    const adminItems = document.querySelectorAll('[data-rol-required="admin"],[data-rol-required="master"]');
    adminItems.forEach(el => el.style.display = 'none');
}

function mostrarMensajeDemo() {
    const toast = document.createElement('div');
    toast.style.cssText = 'position:fixed;bottom:1.5rem;left:50%;transform:translateX(-50%);background:linear-gradient(135deg,#b45309,#d97706);color:#fff;padding:.75rem 1.5rem;border-radius:12px;font-size:.85rem;font-weight:600;z-index:12000;box-shadow:0 8px 24px rgba(0,0,0,.3);display:flex;align-items:center;gap:.75rem';
    toast.innerHTML = '✨ Disponible con tu cuenta &nbsp;<button onclick="abrirRegistroProspecto()" style="background:#fff;color:#92400e;border:none;border-radius:6px;padding:3px 10px;font-weight:700;cursor:pointer;font-size:.8rem">Registrarme</button>';
    document.body.appendChild(toast);
    setTimeout(() => toast.remove(), 4000);
}

function abrirRegistroProspecto() {
    const modal = document.getElementById('modalRegistroProspecto');
    if (modal) modal.style.display = 'flex';
}

async function enviarRegistroProspecto() {
    const nombre   = document.getElementById('rp-nombre')?.value?.trim();
    const whatsapp = document.getElementById('rp-whatsapp')?.value?.trim();
    const email    = document.getElementById('rp-email')?.value?.trim();
    const cedis    = document.getElementById('rp-cedis')?.value;
    const canal    = document.getElementById('rp-canal')?.value;
    const errEl    = document.getElementById('rpError');

    if (!nombre || !whatsapp) {
        if (errEl) { errEl.textContent = 'Nombre y WhatsApp son requeridos.'; errEl.style.display='block'; }
        return;
    }
    if (errEl) errEl.style.display = 'none';

    try {
        await fetch('/webhook/bo/prospecto/registro', {
            method:'POST',
            headers:{'Content-Type':'application/json'},
            body: JSON.stringify({ nombre, whatsapp, email, cedis, canal, fecha: new Date().toISOString() })
        });
    } catch(e) { /* offline fallback — muestra éxito igual */ }

    // Ocultar modal y mostrar confirmación
    document.getElementById('modalRegistroProspecto').style.display = 'none';
    const banner = document.getElementById('demoBanner');
    if (banner) {
        banner.style.background = 'linear-gradient(90deg,#065f46,#059669)';
        banner.innerHTML = '<span style="font-size:1.1rem">✅</span><div style="flex:1;color:#fff;font-size:.85rem;font-weight:600">¡Solicitud enviada! Un asesor de Dulet te contactará a tu WhatsApp en breve.</div>';
    }
}

// ── Auto-activar cuando el usuario es prospecto ───────────────
document.addEventListener('DOMContentLoaded', () => {
    // Checar si ya está autenticado como prospecto
    const storedUser = (() => { try { return JSON.parse(localStorage.getItem('bo_user')||'{}'); } catch {return {};} })();
    if (storedUser?.rol === 'prospecto' || storedUser?.estatus === 'nuevo') {
        activarModoProspecto();
    }
});

// Lógica de Dark/Light Mode
        function toggleTheme() {
            const isLight = document.body.classList.toggle('theme-light');
            localStorage.setItem('bo_theme', isLight ? 'light' : 'dark');
            updateThemeIcon();
            if (typeof loadIngresosPago === 'function') loadIngresosPago();
            if (typeof renderAlertasPage === 'function' && window.RESCATES_DATA) renderAlertasPage(window.RESCATES_PAGE || 0);
        }
        function updateThemeIcon() {
            const isLight = document.body.classList.contains('theme-light');
            const sun = document.querySelector('#themeToggleBtn .icon-sun');
            const moon = document.querySelector('#themeToggleBtn .icon-moon');
            if (sun && moon) {
                sun.style.display = isLight ? 'block' : 'none';
                moon.style.display = isLight ? 'none' : 'block';
            }
        }
        // Inicializar Tema preferido
        if (localStorage.getItem('bo_theme') === 'light') {
            document.body.classList.add('theme-light');
        }
        document.addEventListener('DOMContentLoaded', updateThemeIcon);
        
        // Listener Catálogo de Estados (Formulario Nuevo Líder)
        document.addEventListener('DOMContentLoaded', () => {
            const paisSelect = document.getElementById('nl-pais');
            if (paisSelect) {
                paisSelect.addEventListener('change', async (e) => {
                    const countryCode = e.target.value;
                    const cEstado = document.getElementById('nl-estado');
                    if (!cEstado) return;

                    cEstado.innerHTML = '<option value="">Cargando estados...</option>';
                    cEstado.disabled = true;

                    if (!countryCode) {
                        cEstado.innerHTML = '<option value="">Selecciona País Primero</option>';
                        cEstado.disabled = true;
                        return;
                    }

                    try {
                        const url = 'https://n8n.duletias3rver.com/webhook/bo/estados?pais_id=' + encodeURIComponent(countryCode);
                        const res = await fetch(url);
                        const estados = await res.json();
                        
                        // Populate
                        cEstado.innerHTML = '<option value="">Selecciona Estado / Provincia</option>';
                        estados.forEach(est => {
                            const opt = document.createElement('option');
                            opt.value = est.nombre; // O usar est.id si la BD lo permitiera, pero mantenemos compatibilidad por ahora.
                            opt.textContent = est.nombre;
                            cEstado.appendChild(opt);
                        });
                        cEstado.disabled = false;
                    } catch (err) {
                        console.error('Error cargando estados', err);
                        cEstado.innerHTML = '<option value="">Error cargando estados</option>';
                    }
                });
            }
        });

        // Lógica de Menú Móvil
        function toggleMobileMenu() {
            const sidebar = document.getElementById('sidebar');
            const overlay = document.getElementById('mobileOverlay');
            sidebar.classList.toggle('open');
            overlay.classList.toggle('open');
            if (sidebar.classList.contains('open')) {
                document.body.style.overflow = 'hidden'; // Prevenir scroll de fondo
            } else {
                document.body.style.overflow = '';
            }
        }
        
        // Auto-cerrar menú al hacer clic en un link en móvil
        document.addEventListener('click', (e) => {
            if (window.innerWidth <= 768 && e.target.closest('.nav-item')) {
                const sidebar = document.getElementById('sidebar');
                if (sidebar.classList.contains('open')) toggleMobileMenu();
            }
        });

        /* ====================================================
         * FASE 4: PLATAFORMA DE ACELERACIÓN DE LÍDERES
         * ==================================================== */

        // Inyectando estilo personalizado para el FullCalendar en Dark Mode
        const calendarStyles = document.createElement('style');
        calendarStyles.innerHTML = `
            body:not(.theme-light) .fc {
                --fc-page-bg-color: transparent !important;
                --fc-neutral-bg-color: rgba(255, 255, 255, 0.05);
                --fc-neutral-text-color: #A1A1AA;
                --fc-border-color: rgba(255, 255, 255, 0.1);
                color: #A1A1AA;
            }
            body:not(.theme-light) .fc-theme-standard .fc-scrollgrid,
            body:not(.theme-light) .fc-theme-standard td,
            body:not(.theme-light) .fc-theme-standard th {
                border-color: rgba(255, 255, 255, 0.1);
            }
            body:not(.theme-light) .fc-day-today {
                background: rgba(59, 130, 246, 0.1) !important;
            }
        `;
        document.head.appendChild(calendarStyles);
        
        // Modales Helpers
        function abrirModalCalendario() { document.getElementById('modalNuevaCampana').style.display = 'flex'; }
        
        let proyectoChecklist = [];
        function abrirModalProyecto() { 
            document.getElementById('modalNuevoProyecto').style.display = 'flex'; 
            proyectoChecklist = [];
            renderPuntosAcuerdo();
        }

        function agregarPuntoAcuerdo() {
            const input = document.getElementById('proyecto-nuevo-punto');
            const texto = input.value.trim();
            if(!texto) return;
            proyectoChecklist.push(texto);
            input.value = '';
            renderPuntosAcuerdo();
        }

        function eliminarPuntoAcuerdo(index) {
            proyectoChecklist.splice(index, 1);
            renderPuntosAcuerdo();
        }

        function renderPuntosAcuerdo() {
            const container = document.getElementById('proyecto-checklist-container');
            const emptyLabel = document.getElementById('proyecto-checklist-empty');
            
            if(proyectoChecklist.length === 0) {
                container.innerHTML = '<div style="color:var(--text-dim); font-size:0.8rem; font-style:italic;" id="proyecto-checklist-empty">Sin puntos de acuerdo aún.</div>';
                return;
            }

            container.innerHTML = '';
            proyectoChecklist.forEach((punto, i) => {
                const fila = document.createElement('div');
                fila.style.display = 'flex';
                fila.style.justifyContent = 'space-between';
                fila.style.alignItems = 'center';
                fila.style.padding = '0.5rem';
                fila.style.background = 'rgba(255,255,255,0.03)';
                fila.style.border = '1px solid var(--border-mid)';
                fila.style.borderRadius = 'var(--radius-sm)';
                fila.style.fontSize = '0.85rem';
                
                fila.innerHTML = `
                    <div style="display:flex; align-items:center; gap:0.5rem; color:var(--text-primary);">
                        <input type="checkbox" disabled checked style="opacity:0.5;">
                        <span style="word-break:break-all;">${punto}</span>
                    </div>
                    <button style="background:none; border:none; color:var(--danger); cursor:pointer; font-weight:bold; font-size:1.1rem; padding:0 0.4rem;" onclick="eliminarPuntoAcuerdo(${i})">×</button>
                `;
                container.appendChild(fila);
            });
        }

        async function guardarCampana() {
            const titulo = document.getElementById('campana-titulo').value.trim();
            const inicio = document.getElementById('campana-inicio').value;
            const fin = document.getElementById('campana-fin').value;
            const color = document.getElementById('campana-color').value;
            const desc = document.getElementById('campana-desc').value.trim();

            if(!titulo || !inicio || !fin) return BO_AUTH.showAlert("El título y las fechas son obligatorias", "error");

            try {
                const btn = document.querySelector('button[onclick="guardarCampana()"]');
                btn.disabled = true;
                btn.innerHTML = 'Guardando...';

                await BO_API.crearCampana({ 
                    titulo, 
                    inicio, 
                    fin, 
                    color, 
                    descripcion: desc,
                    creado_por: CURRENT_USER ? CURRENT_USER.id : null,
                    creado_por_nombre: CURRENT_USER ? `${CURRENT_USER.nombre} ${CURRENT_USER.apellido}` : 'Sistema'
                });
                
                BO_AUTH.showAlert('Campaña creada exitosamente', 'success');
                
                document.getElementById('modalNuevaCampana').style.display = 'none';

                // Recargar el calendario si está visible
                if (typeof _initCalendarioCorporativo === 'function') {
                    _initCalendarioCorporativo();
                }

                btn.disabled = false;
                btn.innerHTML = 'Guardar Campaña';

                // Limpiar campos
                document.getElementById('campana-titulo').value = '';
                document.getElementById('campana-inicio').value = '';
                document.getElementById('campana-fin').value = '';
                document.getElementById('campana-desc').value = '';
            } catch (e) {
                BO_AUTH.showAlert('Error al crear campaña', 'error');
                document.querySelector('button[onclick="guardarCampana()"]').disabled = false;
                document.querySelector('button[onclick="guardarCampana()"]').innerHTML = 'Guardar Campaña';
            }
        }
        async function guardarProyecto() {
            const uidStr = document.getElementById('proyecto-lider-id').value.trim();
            const liderId = parseInt(uidStr);
            const titulo = document.getElementById('proyecto-titulo').value.trim();
            const fInicio = document.getElementById('proyecto-inicio').value;
            const fFin = document.getElementById('proyecto-fin').value;
            
            if(!liderId || !titulo || !fInicio || !fFin) {
                alert('Por favor completa todos los campos (ID, Nombre, Fechas)');
                return;
            }
            if(proyectoChecklist.length === 0) {
                alert('Por favor agrega al menos un Punto de Acuerdo (Checklist) para asignarle al Líder');
                return;
            }

            // Convertir array simple a objeto map { "punto1": false }
            const checklistMap = {};
            proyectoChecklist.forEach(p => checklistMap[p] = false);

            const payload = {
                lider_registro: liderId,
                titulo: titulo,
                fecha_inicio: fInicio,
                fecha_fin: fFin,
                checklist: checklistMap
            };

            try {
                // Notificar al usuario (simula botón loading)
                const btn = document.querySelector('#modalNuevoProyecto .btn-primary');
                const origTxt = btn.textContent;
                btn.textContent = 'Guardando...';
                btn.disabled = true;

                await BO_API.saveAcelerador(payload);
                alert('¡Proyecto asignado exitosamente al Líder #' + liderId + '!');
                document.getElementById('modalNuevoProyecto').style.display = 'none';

                // Si estamos viendo el mismo líder, podríamos forzar un refresco, pero
                // as-is está bien.
                
                // Restaurar botón
                btn.textContent = origTxt;
                btn.disabled = false;
            } catch (err) {
                alert('Error al guardar el proyecto: ' + err.message);
                const btn = document.querySelector('#modalNuevoProyecto .btn-primary');
                btn.textContent = 'Crear Proyecto';
                btn.disabled = false;
            }
        }
        
        let calendarInstance = null;
        async function _initCalendarioCorporativo() {
            window.calendarInstance = calendarInstance;
            window._initCalendarioCorporativo = _initCalendarioCorporativo;
            const _rolCal = (CURRENT_USER?.rol || '').toLowerCase() === 'administrador' ? 'admin' : (CURRENT_USER?.rol || '').toLowerCase();
            const adminCtrl = document.getElementById('calendario-admin-controls');
            if (adminCtrl) {
                adminCtrl.style.display = ['master', 'admin'].includes(_rolCal) ? 'flex' : 'none';
            }

            if (!calendarInstance) {
                const calendarEl = document.getElementById('calendar-container');
                if (!calendarEl) {
                    console.warn('[Calendario] No se encontró #calendar-container en el DOM');
                    return;
                }
                if (typeof FullCalendar === 'undefined') {
                    console.error('[Calendario] La librería FullCalendar no está cargada');
                    return;
                }
                calendarInstance = new FullCalendar.Calendar(calendarEl, {
                    initialView: 'dayGridMonth',
                    locale: 'es',
                    headerToolbar: { left: 'prev,next today', center: 'title', right: '' },
                    eventClick: function(info) { 
                        const title = info.event.title;
                        
                        // Parse local dates directly to avoiding timezone shifts again in display
                        let startStr = info.event.startStr || '';
                        let endStr = info.event.endStr || startStr;
                        
                        if (info.event.allDay) {
                            if(endStr && startStr !== endStr) {
                                // FullCalendar returns the exclusive end date for all-day events. 
                                // Backtrack 1 day for intuitive display to the user.
                                let endOnlyDate = endStr.split('T')[0];
                                let d = new Date(endOnlyDate + 'T12:00:00');
                                d.setDate(d.getDate() - 1);
                                endStr = d.toISOString().split('T')[0];
                            }
                            startStr = startStr.split('T')[0];
                        } else {
                            // Formatting for timed events safely using Date objects
                            const fOpt = { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' };
                            startStr = info.event.start ? info.event.start.toLocaleString('es-ES', fOpt) : startStr;
                            endStr = info.event.end ? info.event.end.toLocaleString('es-ES', fOpt) : endStr;
                        }
                        
                        const desc = info.event.extendedProps.descripcion || 'Sin descripción';
                        const creador = info.event.extendedProps.creado_por_nombre || 'Desconocido';
                        const creador_id = String(info.event.extendedProps.creado_por || '');
                        const event_id = info.event.extendedProps.id || info.event.id;
                        const currentUser = String(CURRENT_USER?.id || '');
                        const isMasterAdmin = ['master','admin','administrador'].includes((CURRENT_USER?.rol || '').toLowerCase());

                        let deleteHTML = '';
                        if (creador_id === currentUser || isMasterAdmin) {
                            deleteHTML = `
                            <button onclick="window.borrarCampanaHandler(${event_id}, this)" style="background:var(--danger); color:white; border:none; padding:10px 15px; border-radius:8px; cursor:pointer; font-weight:600; font-size: 0.9rem; margin-top:20px; width:100%; transition: all 0.2s;">
                                🗑️ Borrar Campaña
                            </button>`;
                        }

                        const modalOverlay = document.createElement('div');
                        modalOverlay.className = 'calendar-modal-overlay';
                        modalOverlay.style.position = 'fixed';
                        modalOverlay.style.top = '0';
                        modalOverlay.style.left = '0';
                        modalOverlay.style.width = '100vw';
                        modalOverlay.style.height = '100vh';
                        modalOverlay.style.background = 'rgba(0,0,0,.65)';
                        modalOverlay.style.backdropFilter = 'blur(16px)';
                        modalOverlay.style.WebkitBackdropFilter = 'blur(16px)';
                        modalOverlay.style.zIndex = '10600';
                        modalOverlay.style.display = 'flex';
                        modalOverlay.style.justifyContent = 'center';
                        modalOverlay.style.alignItems = 'center';

                        const modalBox = document.createElement('div');
                        modalBox.style.background = 'var(--bg-card)';
                        modalBox.style.borderRadius = '12px';
                        modalBox.style.padding = '1.8rem';
                        modalBox.style.width = '90%';
                        modalBox.style.maxWidth = '420px';
                        modalBox.style.boxShadow = '0 25px 50px -12px rgba(0, 0, 0, 0.5)';
                        modalBox.style.position = 'relative';
                        modalBox.style.border = '1px solid var(--border-mid)';
                        modalBox.style.color = 'var(--text-main)';

                        modalBox.innerHTML = `
                            <button style="position:absolute; top:15px; right:15px; background:var(--bg); border:1px solid var(--border); border-radius:50%; width:30px; height:30px; color:var(--text-dim); font-size:1.1rem; cursor:pointer; display:flex; align-items:center; justify-content:center;" onclick="this.parentElement.parentElement.remove()">×</button>
                            <h3 style="margin-top:0; color:${info.event.backgroundColor || 'var(--primary)'}; border-bottom:1px solid var(--border); padding-bottom:12px; font-size:1.3rem; display:flex; align-items:center; gap:8px;">
                                📅 <span>${title}</span>
                            </h3>
                            <div style="background:var(--bg); border-radius:8px; padding:12px; margin:15px 0;">
                                <p style="font-size:0.9rem; color:var(--text-main); margin:0 0 8px 0; display:flex; align-items:center; gap:8px;"><strong>▶️ Inicio:</strong> <span>${startStr}</span></p>
                                <p style="font-size:0.9rem; color:var(--text-main); margin:0; display:flex; align-items:center; gap:8px;"><strong>⏹ Fin:</strong> <span>${endStr}</span></p>
                            </div>
                            <p style="font-size:0.95rem; color:var(--text-dim); line-height:1.5;">${desc}</p>
                            <div style="margin-top:20px; font-size:0.85rem; color:var(--text-muted); display:flex; justify-content:flex-end; align-items:center; gap:5px; border-top:1px dashed var(--border); padding-top:15px;">
                                <span>Subido por:</span> <strong style="color:var(--text-main);">${creador}</strong>
                            </div>
                            ${deleteHTML}
                        `;

                        modalOverlay.appendChild(modalBox);
                        document.body.appendChild(modalOverlay);
                    }
                });
                calendarInstance.render();
                window.calendarInstance = calendarInstance;
            } else {
                setTimeout(() => {
                    try { if (calendarInstance) calendarInstance.updateSize(); } catch (e) {}
                }, 100);
            }

            try {
                if (calendarInstance) calendarInstance.removeAllEvents();
                let rawRes = await BO_API.getCalendario();
                let res = rawRes?.data ? rawRes.data : rawRes;

                if (res) {
                    if (!Array.isArray(res)) res = [res];
                    res.forEach(c => {
                        // Fix for UTC timezone shift and apply explicit colors!
                        let isAllDayLocal = false;
                        let startIsMidnight = c.start && (c.start.length === 10 || c.start.includes('T00:00:00'));
                        let endIsMidnight = !c.end || c.end.length === 10 || c.end.includes('T00:00:00');
                        
                        if(startIsMidnight && endIsMidnight) {
                            isAllDayLocal = true;
                            c.start = c.start.split('T')[0];
                            if(c.end) {
                                // FullCalendar "end" for all-day events is exclusive. 
                                // Add 1 day to correctly span the full block visually
                                let d = new Date(c.end.split('T')[0] + 'T12:00:00');
                                d.setDate(d.getDate() + 1);
                                c.end = d.toISOString().split('T')[0];
                            }
                        } else {
                            if(c.start) c.start = c.start.replace('Z', '');
                            if(c.end) c.end = c.end.replace('Z', '');
                        }
                        c.allDay = isAllDayLocal;
                        if(c.color) {
                            c.backgroundColor = c.color;
                            c.borderColor = c.color;
                        }
                        c.extendedProps = {
                            id: c.id, // Guardar el ID también en extendedProps por seguridad
                            descripcion: c.descripcion,
                            creado_por: c.creado_por,
                            creado_por_nombre: c.creado_por_nombre
                        };
                        calendarInstance.addEvent(c);
                    });
                }
            } catch (err) {
                // Ignore "No item" because it simply means the database has 0 campaigns
                if (!err.message || !err.message.includes("No item to return was found")) {
                    console.error("Error Calendario", err);
                }
            }
        }

        // Handler global para borrar desde el pop-up dinámico del calendario
        window.borrarCampanaHandler = async function(event_id, btn) {
            if(confirm('¿Estás seguro de que deseas borrar esta campaña?')) {
                btn.disabled = true;
                btn.innerHTML = 'Borrando...';
                try {
                    await BO_API.deleteCampana(event_id);
                    BO_AUTH.showAlert('Campaña borrada', 'success');
                    btn.closest('.calendar-modal-overlay').remove();
                    _initCalendarioCorporativo();
                } catch(e) {
                    BO_AUTH.showAlert('Error al borrar', 'error');
                    btn.disabled = false;
                    btn.innerHTML = '🗑️ Borrar Campaña';
                }
            }
        };

        let chartAceleradorCtx = null;
        let proyectosAceleradorActuales = [];
        let proyectosAceleradorConcluidos = [];

        async function loadAcelerador() {
            const isAdmin = isAdminOrMaster();
            if (isAdmin) {
                document.getElementById('acelerador-admin-controls').style.display = 'block';
            } else {
                document.getElementById('acelerador-admin-controls').style.display = 'none';
            }

            try {
                // Pedimos el ID del líder actualmente visualizado (si es master) o el propio
                // Window.__currentLiderUid fue usado en 'Mi Perfil' / árbol.
                // Para admin/master sin un líder específico: trae TODOS los proyectos (uid=all)
                // Para admin con líder seleccionado (modo espejo): filtra por ese líder
                // Para cliente/lider: solo sus propios proyectos
                let targetUid;
                if (isAdmin) {
                    targetUid = window.__currentLiderUid || 'all';
                } else {
                    targetUid = CURRENT_USER.registro;
                }
                const res = await BO_API.getAcelerador(targetUid);
                
                proyectosAceleradorActuales = res.actuales || [];
                proyectosAceleradorConcluidos = res.concluidos || [];

                const mainContainer = document.getElementById('acelerador-main-container');
                const emptyState = document.getElementById('acelerador-empty-state');

                if (!res.hasProject && !isAdmin) {
                    emptyState.style.display = 'flex';
                    mainContainer.style.display = 'none';
                    return;
                }
                // Admin sin proyectos en el sistema: mostrar mensaje especial
                if (!res.hasProject && isAdmin) {
                    emptyState.innerHTML = `
                        <div style="font-size:4rem; margin-bottom:1rem;">📋</div>
                        <h3 style="font-size:1.3rem; margin-bottom:0.5rem;">No hay proyectos asignados aún</h3>
                        <p style="color:var(--text-dim); max-width:400px; font-size:0.9rem;">Usa el botón "+ Nuevo Proyecto" para asignar el primer proyecto de aceleración a un líder.</p>
                    `;
                    emptyState.style.display = 'flex';
                    mainContainer.style.display = 'none';
                    return;
                }
                
                emptyState.style.display = 'none';
                mainContainer.style.display = 'grid';

                renderListasProyectos();

                // Seleccionar el primero por defecto
                if (proyectosAceleradorActuales.length > 0) {
                    seleccionarProyecto(proyectosAceleradorActuales[0]);
                } else if (proyectosAceleradorConcluidos.length > 0) {
                    seleccionarProyecto(proyectosAceleradorConcluidos[0]);
                } else {
                    document.getElementById('acelerador-details-panel').style.display = 'none';
                }

            } catch(e) {
                console.error("Error cargando Acelerador", e);
                document.getElementById('acelerador-main-container').innerHTML = `<div style="padding: 2rem; color: var(--error); text-align: center;">⚠️ No se pudo conectar al servidor (n8n).<br><small>Verifica tu conexión a Tailscale o el estatus del servidor. Error: ${e.message}</small></div>`;
            }
        }

        function renderListasProyectos() {
            const listAct = document.getElementById('lista-proyectos-actuales');
            const listConc = document.getElementById('lista-proyectos-concluidos');
            const isAdmin = isAdminOrMaster();

            const renderObj = (p, container, isActivo) => {
                const div = document.createElement('div');
                div.className = 'val-pildora';
                
                let bgStyle = isActivo 
                    ? 'background:rgba(16,185,129,0.1); border:1px solid rgba(16,185,129,0.3);' 
                    : 'background:rgba(255,255,255,0.03); border:1px solid var(--border);';
                
                div.style.cssText = `position:relative; padding:0.6rem 1rem; ${bgStyle} border-radius:var(--radius-sm); cursor:pointer; color:var(--text-main); font-size:0.85rem; transition:all 0.2s;`;
                
                const asigName = _regNombres[p.lider_registro] || ('Líder #' + p.lider_registro);
                const statTxt = isActivo 
                    ? `<span style="font-size:0.75rem; color:var(--success);">Activo hasta ${new Date(p.fecha_fin).toLocaleDateString()}</span>` 
                    : `<span style="font-size:0.75rem; color:var(--text-dim);">Concluido el ${new Date(p.fecha_fin).toLocaleDateString()}</span>`;
                
                let btnHtml = '';
                if (isAdmin) {
                    btnHtml = `<button onclick="event.stopPropagation(); borrarAceleradorProyecto(${p.id})" style="position:absolute; right:0.5rem; top:0.5rem; background:transparent; border:none; cursor:pointer; color:var(--error); font-size:0.8rem;" title="Eliminar proyecto">🗑️</button>`;
                }

                div.innerHTML = `
                    ${btnHtml}
                    <strong>${p.titulo}</strong><br>
                    <div style="font-size:0.75rem; color:var(--text-muted); margin-top:0.15rem;">👤 ${asigName}</div>
                    ${statTxt}
                `;
                div.onclick = () => seleccionarProyecto(p);
                container.appendChild(div);
            };

            listAct.innerHTML = proyectosAceleradorActuales.length === 0 ? '<div style="color:var(--text-dim);font-size:0.8rem;">Sin proyectos activos</div>' : '';
            proyectosAceleradorActuales.forEach(p => renderObj(p, listAct, true));

            listConc.innerHTML = proyectosAceleradorConcluidos.length === 0 ? '<div style="color:var(--text-dim);font-size:0.8rem;">Ningún proyecto concluido</div>' : '';
            proyectosAceleradorConcluidos.forEach(p => renderObj(p, listConc, false));
        }

        async function borrarAceleradorProyecto(id) {
            if(!confirm('¿Estás seguro de que deseas borrar este proyecto permanentemente?')) return;
            try {
                await BO_API.deleteAcelerador(id);
                alert('Proyecto borrado exitosamente.');
                loadAcelerador(); // Recargar la lista completa
            } catch(e) {
                console.error("Error al borrar el proyecto:", e);
                alert('Ocurrió un error al intentar borrar el proyecto.');
            }
        }

        async function seleccionarProyecto(p) {
            document.getElementById('acelerador-details-panel').style.display = 'flex';
            
        // Timer logic — usa fecha real, no el campo estatus (que puede estar desactualizado)
            const ahora = new Date();
            ahora.setHours(0, 0, 0, 0);
            const fin = new Date(p.fecha_fin);
            fin.setHours(23, 59, 59, 0);
            const estaActivo = (p.estatus === 'activo') && (fin >= ahora);

            const timerEl = document.getElementById('acelerador-timer');
            const timerMsg = document.getElementById('acelerador-timer-msg');

            if (estaActivo) {
                const diffTime = fin - ahora;
                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                timerEl.textContent = `${diffDays} Día${diffDays !== 1 ? 's' : ''} Restante${diffDays !== 1 ? 's' : ''}`;
                timerEl.style.color = diffDays <= 3 ? 'var(--warning)' : 'var(--success)';
                timerMsg.textContent = `Para finalizar el "${p.titulo}"`;
            } else {
                // Proyecto concluido — mostrar rango de fechas
                const fmtOpts = { day: 'numeric', month: 'short', year: 'numeric' };
                const inicio = new Date(p.fecha_inicio).toLocaleDateString('es-MX', fmtOpts);
                const finStr = new Date(p.fecha_fin).toLocaleDateString('es-MX', fmtOpts);
                timerEl.textContent = 'CONCLUIDO';
                timerEl.style.color = 'var(--text-dim)';
                timerMsg.textContent = `"${p.titulo}" · de ${inicio} al ${finStr}`;
            }

            // Render Checklist dinamico
            const container = document.getElementById('acelerador-checklist-container');
            container.innerHTML = '';
            
            let checklist = p.checklist || {};
            // Soporte para legacy: Si llega un array (por si acaso), lo acomodamos
            if (Array.isArray(checklist)) {
                const newC = {};
                checklist.forEach(i => newC[i] = false);
                checklist = newC;
            }

            Object.keys(checklist).forEach(punto => {
                const marcado = checklist[punto] === true;
                const uidRmd = Math.random().toString(36).substring(7);
                const div = document.createElement('div');
                div.style.cssText = 'display:flex; align-items:flex-start; gap:0.6rem; padding:0.5rem; border-radius:4px; transition:background 0.2s;';
                
                // Escape para inyección en inline onclick
                const puntoEscaped = punto.replace(/'/g, "\\'").replace(/"/g, '&quot;');
                
                div.innerHTML = `
                    <input type="checkbox" id="chk_${uidRmd}" ${marcado ? 'checked' : ''} 
                        style="margin-top:0.2rem; transform:scale(1.1); cursor:pointer;"
                        onchange="toggleCheckAcelerador(${p.id}, '${puntoEscaped}', this.checked, this, ${p.lider_registro})">
                    <label for="chk_${uidRmd}" style="cursor:pointer; color:var(--text-main); font-size:0.9rem; line-height:1.4;">${punto}</label>
                `;
                container.appendChild(div);
            });

            // Generación de Serie de Tiempo Dinámica
            const start = new Date(p.fecha_inicio);
            const end = new Date(p.fecha_fin);
            const diffDaysTime = Math.ceil(Math.abs(end - start) / (1000 * 60 * 60 * 24));
            
            let timeLabels = [];
            if (diffDaysTime <= 31) {
                for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
                    timeLabels.push(d.toLocaleDateString('es-ES', { month: 'short', day: 'numeric' }));
                }
            } else if (diffDaysTime <= 120) {
                let w = 1;
                for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 7)) {
                    timeLabels.push(`Sem. ${w++}`);
                }
            } else {
                for (let d = new Date(start); d <= end; d.setMonth(d.getMonth() + 1)) {
                    timeLabels.push(d.toLocaleDateString('es-ES', { month: 'short', year: '2-digit' }));
                }
            }

            // Fetch real DB metrics
            let rawMetrics = [];
            try {
                // p.id, p.lider_registro, p.fecha_inicio, p.fecha_fin
                document.getElementById('chartAcelerador').parentElement.style.opacity = '0.5';
                const resp = await BO_API.getAceleradorMetricas(p.id, p.lider_registro, start.toISOString().split('T')[0], end.toISOString().split('T')[0]);
                if (Array.isArray(resp)) {
                    rawMetrics = resp;
                }
            } catch(e) {
                console.warn("Error fetcheando metricas", e);
            } finally {
                document.getElementById('chartAcelerador').parentElement.style.opacity = '1';
            }

            // Datos Mock -> Real mapping logic (bucket processing)
            const len = timeLabels.length;
            const valuesVentas = new Array(len).fill(0);
            const valuesVentasAnt = new Array(len).fill(0);
            const valuesInscritos = new Array(len).fill(0);
            const mockInscritosAnt = Array.from({length: len}, () => Math.floor(Math.random() * 5)); // To keep background trend

            // Grouping function (map DB d_date to index of labels)
            rawMetrics.forEach(row => {
                if(!row.d_date) return;
                const dDateStr = row.d_date.substring(0,10);
                const rwDate = new Date(dDateStr);
                
                // Which bucket?
                const diffTime = rwDate - start;
                let bIdx = -1;
                
                if (diffDaysTime <= 31) { // day bucket
                    bIdx = Math.floor(diffTime / (1000 * 60 * 60 * 24));
                } else if (diffDaysTime <= 120) { // week bucket
                    bIdx = Math.floor(diffTime / (1000 * 60 * 60 * 24 * 7));
                } else { // month bucket
                    const mDiff = (rwDate.getFullYear() - start.getFullYear())*12 + (rwDate.getMonth() - start.getMonth());
                    bIdx = mDiff;
                }

                if(bIdx >= 0 && bIdx < len) {
                    valuesVentas[bIdx] += parseFloat(row.ventas_usd) || 0;
                    valuesInscritos[bIdx] += parseInt(row.inscritos) || 0;
                } else if (bIdx < 0) { // Anterior
                    // Prev period mapping (pseudo mirroring to compare overlap)
                    let pIdx = bIdx + len;
                    if(pIdx >= 0 && pIdx < len) {
                        valuesVentasAnt[pIdx] += parseFloat(row.ventas_usd) || 0;
                        // inscritos_ant mapped via mock for now 
                    }
                }
            });

            if (chartAceleradorCtx) chartAceleradorCtx.destroy();
            const ctx = document.getElementById('chartAcelerador')?.getContext('2d');
            if(ctx) {
                Chart.defaults.color = '#A1A1AA';
                chartAceleradorCtx = new Chart(ctx, {
                    data: {
                        labels: timeLabels,
                        datasets: [
                            {
                                type: 'bar',
                                label: 'Ventas Actuales ($)',
                                data: valuesVentas.some(v=>v>0) ? valuesVentas : Array.from({length:len},()=>Math.floor(Math.random()*2000)), // fallback mock si todo da 0
                                backgroundColor: p.estatus=='activo' ? 'rgba(16, 185, 129, 0.4)' : 'rgba(59,130,246,0.3)',
                                borderColor: p.estatus=='activo' ? '#10B981' : '#3B82F6',
                                borderWidth: 1,
                                yAxisID: 'y1'
                            },
                            {
                                type: 'bar',
                                label: 'Ventas Anterior ($)',
                                data: valuesVentasAnt.some(v=>v>0)? valuesVentasAnt: Array.from({length:len},()=>Math.floor(Math.random()*1500)),
                                backgroundColor: 'rgba(255,255,255,0.05)',
                                borderColor: 'rgba(255,255,255,0.1)',
                                borderWidth: 1,
                                yAxisID: 'y1'
                            },
                            {
                                type: 'line',
                                label: 'Inscritos N4',
                                data: valuesInscritos.some(v=>v>0)? valuesInscritos : Array.from({length:len},()=>Math.floor(Math.random()*4)),
                                borderColor: '#eab308', // Yellow for new members
                                backgroundColor: '#eab308',
                                tension: 0.3,
                                borderWidth: 2,
                                yAxisID: 'y2'
                            },
                            {
                                type: 'line',
                                label: 'Inscritos Ant.',
                                data: mockInscritosAnt,
                                borderColor: 'rgba(234, 179, 8, 0.3)',
                                borderDash: [5, 5],
                                tension: 0.3,
                                borderWidth: 2,
                                yAxisID: 'y2'
                            }
                        ]
                    },
                    options: { 
                        responsive: true, 
                        maintainAspectRatio: false, 
                        scales: { 
                            x: { grid: { display: false } },
                            y1: { 
                                type: 'linear', position: 'left', 
                                title: { display: true, text: 'Ventas (USD)' },
                                grid: { color: 'rgba(255,255,255,0.05)' }
                            },
                            y2: { 
                                type: 'linear', position: 'right', 
                                title: { display: true, text: 'Personas (N4)' },
                                grid: { drawOnChartArea: false } // No empalmar mallas
                            }
                        } 
                    }
                });
            }
        }

        async function toggleCheckAcelerador(projectId, puntoDesc, isChecked, chkElement, lider_registro) {
            chkElement.disabled = true; // Prevents race conditions
            
            // Local update (encontrar el proyecto en la RAM y aplicarlo)
            let proj = proyectosAceleradorActuales.find(p => p.id === projectId) || proyectosAceleradorConcluidos.find(p => p.id === projectId);
            if (!proj) return;
            
            proj.checklist[puntoDesc] = isChecked;

            try {
                // Call API
                await BO_API.updateAceleradorChecklist(projectId, proj.checklist);
                // Visual feedback opcional
                chkElement.parentElement.style.background = isChecked ? 'rgba(16, 185, 129, 0.05)' : 'transparent';
                setTimeout(() => chkElement.parentElement.style.background = 'transparent', 500);
            } catch(e) {
                console.error("Error actualizando checklist", e);
                alert("Error al guardar el checkpoint en el servidor.");
                proj.checklist[puntoDesc] = !isChecked; // revert local
                chkElement.checked = !isChecked; // revert UI
            } finally {
                chkElement.disabled = false;
            }
        }

        // ==========================================================
        // AUTOCOMPLETE BUSCADOR BITÁCORA
        // ==========================================================
        let _bitacoraLiderTimer = null;
        function buscarLiderBitacora() {
            clearTimeout(_bitacoraLiderTimer);
            _bitacoraLiderTimer = setTimeout(_bitacoraDoSearch, 300);
        }
        
        async function _bitacoraDoSearch() {
            const q = document.getElementById('bitacora-admin-autocomplete')?.value.trim();
            const sugg = document.getElementById('bitacora-admin-sugg');
            document.getElementById('bitacora-admin-input-uid').value = ''; // clear on type
            
            if (!q || q.length < 2) { if(sugg) sugg.style.display='none'; return; }
            
            const ql = q.toLowerCase();
            const terms = ql.split(' ').filter(t => t.length > 0);
            
            // 1. Búsqueda Local (rápida y ya contiene a muchos Platas)
            const fuente = (typeof window.LIDERES_DATA !== 'undefined' && Array.isArray(window.LIDERES_DATA)) ? window.LIDERES_DATA : [];
            let dataLocal = fuente.filter(l => {
                const fullStr = `${l.id} ${l.registro} ${l.nombre||''} ${l.apellido||''} ${l.galardon||''}`.toLowerCase();
                return terms.every(term => fullStr.includes(term));
            });

            let dataServer = [];
            try {
                let res = await BO_API.listUsers({ search: q, limit: 200 });
                const arr = Array.isArray(res) ? res : (res.data || []);
                if (Array.isArray(arr) && (!arr.length || !arr[0].json)) {
                    dataServer = arr;
                }
            } catch(e) {
                console.warn("Fallo listUsers en Bitácora", e);
            }

            // 3. Unir, quitar duplicados por registro y filtrar
            let merged = [...dataLocal, ...dataServer];
            let uniqueMap = new Map();
            merged.forEach(item => {
                const key = item.registro || item.id;
                if (!uniqueMap.has(key)) uniqueMap.set(key, item);
            });
            let unique = Array.from(uniqueMap.values());

            const permitidos = ['plata', 'oro', 'platino', 'diamante', 'corona', 'vicepresidente'];
            let dataFiltrada = unique.filter(l => {
                const validRole = permitidos.includes((l.galardon || '').toLowerCase()) || ['master','admin'].includes(l.rol) || (l.rol_id === '00000000-0000-0000-0000-000000000001') || (l.rol||'').toLowerCase() === 'master' || (l.rol||'').toLowerCase() === 'admin';
                return validRole;
            }).slice(0, 8);

            if (!sugg) return;
            if (!dataFiltrada.length) { sugg.innerHTML = '<div style="padding:.6rem 1rem;color:var(--text-dim);font-size:.8rem">Sin líderes Plata+ encontrados</div>'; sugg.style.display='block'; return; }
            
            sugg.innerHTML = dataFiltrada.map(l => {
                const nombre = (l.nombre||'') + ' ' + (l.apellido||'');
                return `<div class="bitacora-lider-opt" data-reg="${l.registro||l.id}" data-nombre="${nombre.trim()}" style="padding:.5rem 1rem;cursor:pointer;border-bottom:1px solid var(--border)" onmousedown="seleccionarLiderBitacora(this)">
                    <strong>${nombre.trim()}</strong> <span style="color:var(--text-dim)">#${l.registro||l.id}</span>
                </div>`;
            }).join('');
            sugg.style.display = 'block';
        }

        // Close dropdown when losing focus
        document.addEventListener('click', (e) => {
            const sugg = document.getElementById('bitacora-admin-sugg');
            const input = document.getElementById('bitacora-admin-autocomplete');
            if (sugg && input && !sugg.contains(e.target) && e.target !== input) {
                sugg.style.display = 'none';
            }
        });

        function seleccionarLiderBitacora(el) {
            const nombre = el.dataset.nombre;
            const reg = el.dataset.reg;
            document.getElementById('bitacora-admin-autocomplete').value = nombre;
            document.getElementById('bitacora-admin-input-uid').value = reg;
            document.getElementById('bitacora-admin-sugg').style.display = 'none';
            loadBitacora(reg); // Carga la data
        }

        let chartBitacoraCtx = null;
        async function loadBitacora(forceUid = null) {
            const _rolBit = (CURRENT_USER?.rol || '').toLowerCase() === 'administrador' ? 'admin' : (CURRENT_USER?.rol || '').toLowerCase();
            const isAdmin = ['master', 'admin'].includes(_rolBit);
            const selectLider = document.getElementById('bitacora-admin-input-uid');
            const uidToFetch = isAdmin ? (forceUid || selectLider?.value || CURRENT_USER.registro) : CURRENT_USER.registro;
            
            const selMes = document.getElementById('bitacora-month-filter');
            if (selMes && !selMes.value) {
                const now = new Date();
                selMes.value = now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0');
            }
            const mesSelected = selMes?.value || new Date().toISOString().substring(0, 7);
            
            // Generate Spanish text for display ("Abril 2026")
            const d = new Date(mesSelected + '-02'); // Add day to avoid timezone shifting
            const mesText = d.toLocaleString('es-ES', { month: 'long', year: 'numeric' }).replace(/^\w/, c => c.toUpperCase());

            if (isAdmin) {
                document.getElementById('bitacora-admin-inputs').style.display = 'flex';
                const bitSearch = document.getElementById('bitacora-admin-search');
                if (bitSearch) bitSearch.style.display = 'block';
                
                document.getElementById('bitacora-subtitle').textContent = "Evaluación externa de comunidades y grupos";

                // Asegurar que LIDERES_DATA está cargado para el autocompletar
                let dataArray = window.LIDERES_DATA || [];
                if (!Array.isArray(dataArray) || dataArray.length === 0) {
                    try { 
                        const res = await BO_API.listUsers({}); 
                        dataArray = res.data || res || []; 
                        window.LIDERES_DATA = dataArray; 
                    } 
                    catch(e) { 
                        console.warn("Fallo listUsers, usando MOCK", e); 
                        dataArray = BO_API.MOCK?.usuarios || []; 
                        window.LIDERES_DATA = dataArray;
                    }
                }
                const selectLiderHidden = document.getElementById('bitacora-admin-input-uid');
                const autocompText = document.getElementById('bitacora-admin-autocomplete');

                if (isAdmin && selectLiderHidden && uidToFetch) {
                    selectLiderHidden.value = uidToFetch;
                    // Find name
                    const u = dataArray.find(x => x.registro == uidToFetch || x.id == uidToFetch);
                    if (u && autocompText && !autocompText.value) {
                        autocompText.value = `${u.nombre} ${u.apellido}`;
                    }
                }
            } else {
                document.getElementById('bitacora-admin-inputs').style.display = 'none';
                const bitSearch = document.getElementById('bitacora-admin-search');
                if (bitSearch) bitSearch.style.display = 'none';

                // El líder sí puede ver su propio gráfico
                const panelChart = document.querySelector('#view-bitacora .panel:nth-of-type(1)');
                if (panelChart) panelChart.style.display = 'block';
            }

            try {
                // Update panel title
                const panelTitleNode = document.querySelector('#view-bitacora .panel:nth-of-type(2) .panel-title');
                if(panelTitleNode) panelTitleNode.textContent = `Álbum Mensual (${mesText})`;

                const res = await BO_API.getBitacora(uidToFetch, mesSelected);
                const scores = (res.whatsapp || []).map(w => w.estimacion_mensajes).reverse();
                if (scores.length > 0) renderBitacoraChart(scores);
                else renderBitacoraChart([0,0,0,0]);
                
                // Renderizar Evidencias
                const albumNode = document.querySelector('#view-bitacora .panel:nth-of-type(2) .panel-body');
                if(albumNode && res.evidencias) {
                    window.currentEvidencias = res.evidencias;
                    
                    window.renderEvidenciasPage = function(page) {
                        albumNode.innerHTML = '';
                        albumNode.style.display = 'grid';
                        albumNode.style.gridTemplateColumns = 'repeat(auto-fill, minmax(200px, 1fr))';
                        albumNode.style.gap = '1rem';
                        
                        const itemsPerPage = 4;
                        const startIndex = (page - 1) * itemsPerPage;
                        const pageItems = window.currentEvidencias.slice(startIndex, startIndex + itemsPerPage);

                        pageItems.forEach(ev => {
                            const deleteBtn = isAdmin ? `<button onclick="borrarEvidencia(${ev.id}); event.stopPropagation();" style="position:absolute; top:5px; right:5px; background:rgba(239, 68, 68, 0.9); color:white; border:none; border-radius:50%; width:25px; height:25px; cursor:pointer;" title="Borrar Evidencia">🗑️</button>` : '';
                            const fileIdMatch = ev.url_drive.match(/id=([^&]+)/) || ev.url_drive.match(/\/d\/([a-zA-Z0-9_-]+)/);
                            const fileId = fileIdMatch ? fileIdMatch[1] : '';
                            const iframeSrc = fileId ? `https://drive.google.com/file/d/${fileId}/preview` : ev.url_drive;

                            albumNode.innerHTML += `
                            <div onclick="abrirModalPreview('${iframeSrc}', '${fileId}')" style="background:var(--bg); border:1px solid var(--border); border-radius:8px; padding:.5rem; text-align:center; position:relative; cursor:pointer; transition: transform 0.2s; box-shadow: 0 4px 6px rgba(0,0,0,0.1);" onmouseover="this.style.transform='scale(1.02)'" onmouseout="this.style.transform='scale(1)'">
                                ${deleteBtn}
                                <iframe src="${iframeSrc}" style="width:100%; height:140px; border:none; border-radius:4px; margin-bottom:.5rem; pointer-events:none; background:white;"></iframe>
                                <p style="font-size:.75rem; color:var(--text-dim); margin-top:0.5rem;">${ev.comentario || 'Evidencia Subida'}</p>
                            </div>`;
                        });

                        if(window.currentEvidencias.length === 0) {
                            albumNode.innerHTML = `
                            <div style="grid-column: 1 / -1; display:flex; flex-direction:column; align-items:center; justify-content:center; padding: 2rem; color:var(--text-dim); gap: 1rem; opacity: 0.6;">
                                <i class="fa-regular fa-images" style="font-size: 3rem; color:var(--border);"></i>
                                <p style="margin:0; font-size:0.9rem;">No hay evidencias subidas para el mes de ${mesText}</p>
                            </div>`;
                        } else if (window.currentEvidencias.length > itemsPerPage) {
                            const totalPages = Math.ceil(window.currentEvidencias.length / itemsPerPage);
                            const prevDisabled = page === 1 ? 'disabled style="opacity:0.5;cursor:not-allowed;"' : '';
                            const nextDisabled = page === totalPages ? 'disabled style="opacity:0.5;cursor:not-allowed;"' : '';
                            
                            albumNode.innerHTML += `
                            <div style="grid-column: 1 / -1; display:flex; justify-content:center; align-items:center; gap:1rem; margin-top:0.5rem; padding-top:1rem; border-top:1px solid var(--border);">
                                <button class="btn btn-sm" ${prevDisabled} onclick="renderEvidenciasPage(${page - 1})">⬅️ Anterior</button>
                                <span style="color:var(--text-dim); font-size:0.85rem; font-weight:600;">Página ${page} de ${totalPages}</span>
                                <button class="btn btn-sm" ${nextDisabled} onclick="renderEvidenciasPage(${page + 1})">Siguiente ➡️</button>
                            </div>`;
                        }
                    };

                    window.renderEvidenciasPage(1);
                }
            } catch(e) {
                // Mock behavior if API is down
                renderBitacoraChart([0,0,0,0]);
                const albumNode = document.querySelector('#view-bitacora .panel:nth-of-type(2) .panel-body');
                if (albumNode) {
                    albumNode.innerHTML = `
                        <div style="grid-column: 1 / -1; display:flex; flex-direction:column; align-items:center; justify-content:center; padding: 2rem; color:var(--text-dim); gap: 1rem; opacity: 0.6;">
                            <i class="fa-regular fa-images" style="font-size: 3rem; color:var(--border);"></i>
                            <p style="margin:0; font-size:0.9rem;">No hay evidencias subidas para el mes de ${mesText}</p>
                        </div>`;
                }
            }
        }

        function renderBitacoraChart(scores) {
            if (chartBitacoraCtx) chartBitacoraCtx.destroy();
            const ctx = document.getElementById('chartBitacoraWhatsapp')?.getContext('2d');
            if(!ctx) return;
            Chart.defaults.color = '#A1A1AA';
            chartBitacoraCtx = new Chart(ctx, {
                type: 'line',
                data: {
                    labels: ['Sem 1', 'Sem 2', 'Sem 3', 'Sem 4'].slice(0, Math.max(scores.length, 4)),
                    datasets: [{
                        label: 'Interacción Comunal',
                        data: scores,
                        borderColor: '#3B82F6',
                        backgroundColor: 'rgba(59, 130, 246, 0.2)',
                        borderWidth: 3, tension: 0.4, fill: true
                    }]
                },
                options: { responsive: true, maintainAspectRatio: false, scales: { y: { beginAtZero: true, grid: { color: 'rgba(255,255,255,0.05)' } }, x: { grid: { display: false } } } }
            });
        }

        async function submitAuditoriaBitacora() {
            const input = document.getElementById('bitacora-admin-input-score');
            const weekSelect = document.getElementById('bitacora-admin-input-semana');
            if(!input || !input.value) return;
            const uidStr = document.getElementById('bitacora-admin-input-uid')?.value || prompt("Registro del Líder a evaluar:");
            if(!uidStr) return alert("Selecciona un líder primero.");
            
            const selMes = document.getElementById('bitacora-month-filter');
            const mesSelected = selMes ? selMes.value : '2026-04';
            const week = weekSelect ? weekSelect.value : 1;

            try {
                input.disabled = true;
                await BO_API.saveBitacoraAuditoria(uidStr, Number(input.value), mesSelected, week);
                alert("Evaluación subida correctamente.");
                input.value = '';
                input.disabled = false;
                loadBitacora(uidStr); // refresh
            } catch(e) {
                alert("Error al subir evaluación: " + e.message);
                input.disabled = false;
            }
        }

        async function borrarAuditoriaBitacora() {
            if(!confirm("¿Estás seguro de eliminar el último registro de interacción?")) return;
            const uidStr = document.getElementById('bitacora-admin-input-uid')?.value;
            if(!uidStr) return alert("Selecciona un líder primero.");
            
            try {
                await BO_API.post('/bo/fase4/bitacora/auditoria', { uid: uidStr, score: -1, action: 'delete' });
                alert("Última evaluación borrada correctamente.");
                loadBitacora(uidStr);
            } catch(e) {
                alert("Error al borrar evaluación: " + e.message);
            }
        }

        function abrirModalEvidencia() {
            const isAdmin = isAdminOrMaster();
            const selectLider = document.getElementById('bitacora-admin-input-uid');
            const uidDestino = isAdmin ? selectLider?.value : CURRENT_USER.registro;
            
            if (!uidDestino) {
                alert("Selecciona a qué líder le vas a subir el archivo.");
                return;
            }

            // Fill form inputs
            const mesActual = document.getElementById('bitacora-month-filter')?.value || new Date().toISOString().substring(0,7);
            document.getElementById('modalEvidenciaMes').value = mesActual;
            document.getElementById('modalEvidenciaCategoria').value = '';
            document.getElementById('modalEvidenciaArchivo').value = '';
            
            document.getElementById('modalSubirEvidenciaBitacora').style.display = 'flex';
        }

        function cerrarModalEvidencia() {
            document.getElementById('modalSubirEvidenciaBitacora').style.display = 'none';
        }

        async function procesarSubidaEvidencia() {
            const file = document.getElementById('modalEvidenciaArchivo').files[0];
            const categoria = document.getElementById('modalEvidenciaCategoria').value.trim();
            const mesSelected = document.getElementById('modalEvidenciaMes').value;

            if (!mesSelected) return alert("Selecciona el mes de la evidencia.");
            if (!categoria) return alert("Por favor ingresa la categoría o descripción.");
            if (!file) return alert("Por favor selecciona un archivo (Imagen o PDF).");

            const isAdmin = isAdminOrMaster();
            const selectLider = document.getElementById('bitacora-admin-input-uid');
            const uidDestino = isAdmin ? selectLider?.value : CURRENT_USER.registro;

            try {
                const btn = document.getElementById('btnProcesarEvidencia');
                btn.innerHTML = "⏳ Subiendo...";
                btn.disabled = true;

                const formData = new FormData();
                formData.append('data', file);
                formData.append('comentario', categoria);
                formData.append('mes', mesSelected);
                formData.append('uid', uidDestino);
                
                let socioNombre = CURRENT_USER.nombre + ' ' + CURRENT_USER.apellido;
                if (isAdmin) {
                    const adminInputTexto = document.getElementById('bitacora-admin-autocomplete')?.value;
                    if (adminInputTexto) socioNombre = adminInputTexto;
                    formData.append('admin_uploader', CURRENT_USER.registro);
                }
                formData.append('socio_nombre', socioNombre);

                const n8nWebhook = `${BO_API.BASE}/bo/fase4/bitacora/evidencia`;
                const res = await fetch(n8nWebhook, {
                    method: 'POST',
                    body: formData
                });
                
                if (!res.ok) throw new Error("Fallo la transmisión a n8n");
                
                alert("📄 ¡Archivo subido exitosamente!");
                cerrarModalEvidencia();
                
                // Actualizar filtro de la vista principal al mes al que se acaba de subir
                document.getElementById('bitacora-month-filter').value = mesSelected;
                
                loadBitacora(uidDestino); 
                btn.innerHTML = "Subir Material";
                btn.disabled = false;
            } catch(err) {
                alert("Error subiendo archivo: " + err.message);
                const btn = document.getElementById('btnProcesarEvidencia');
                btn.innerHTML = "Subir Material";
                btn.disabled = false;
            }
        }
        function abrirModalPreview(src, fileId) {
            const overlay = document.createElement('div');
            overlay.style.position = 'fixed';
            overlay.style.top = '0';
            overlay.style.left = '0';
            overlay.style.width = '100vw';
            overlay.style.height = '100vh';
            overlay.style.backgroundColor = 'rgba(0,0,0,0.85)';
            overlay.style.zIndex = '999999';
            overlay.style.display = 'flex';
            overlay.style.justifyContent = 'center';
            overlay.style.alignItems = 'center';
            overlay.style.backdropFilter = 'blur(5px)';

            // Contenedor principal que agrupa el iframe y nuestros controles
            const container = document.createElement('div');
            container.style.position = 'relative';
            container.style.width = '85vw';
            container.style.height = '85vh';
            container.style.borderRadius = '8px';
            container.style.overflow = 'hidden';
            container.style.boxShadow = '0 10px 25px rgba(0,0,0,0.5)';
            container.style.backgroundColor = '#000';

            // Iframe de Google Drive
            const iframe = document.createElement('iframe');
            iframe.src = src;
            iframe.style.width = '100%';
            iframe.style.height = '100%';
            iframe.style.border = 'none';

            // Barra superior nuestra que oculta la barra nativa de Google Drive (aprox 55px)
            const topBar = document.createElement('div');
            topBar.style.position = 'absolute';
            topBar.style.top = '0';
            topBar.style.left = '0';
            topBar.style.width = '100%';
            topBar.style.height = '56px';
            topBar.style.backgroundColor = '#1f1f1f'; // Color similar a la barra nativa
            topBar.style.display = 'flex';
            topBar.style.justifyContent = 'space-between';
            topBar.style.alignItems = 'center';
            topBar.style.padding = '0 1rem';
            topBar.style.boxSizing = 'border-box';
            topBar.style.zIndex = '10';

            const title = document.createElement('span');
            title.innerHTML = 'Visualizador de Evidencias';
            title.style.color = '#fff';
            title.style.fontSize = '1.1rem';
            title.style.fontFamily = 'sans-serif';

            const btnContainer = document.createElement('div');
            btnContainer.style.display = 'flex';
            btnContainer.style.gap = '15px';
            btnContainer.style.alignItems = 'center';

            if(fileId) {
                const downloadBtn = document.createElement('button');
                downloadBtn.innerHTML = '⬇️ Descargar';
                downloadBtn.style.background = '#4CAF50';
                downloadBtn.style.color = 'white';
                downloadBtn.style.border = 'none';
                downloadBtn.style.padding = '8px 15px';
                downloadBtn.style.borderRadius = '5px';
                downloadBtn.style.cursor = 'pointer';
                downloadBtn.style.fontSize = '0.9rem';
                downloadBtn.style.fontWeight = 'bold';
                downloadBtn.onclick = () => window.open(`https://drive.google.com/uc?export=download&id=${fileId}`, '_blank');
                btnContainer.appendChild(downloadBtn);
            }

            const closeBtn = document.createElement('button');
            closeBtn.innerHTML = '✖ Cerrar';
            closeBtn.style.background = 'rgba(239, 68, 68, 0.9)';
            closeBtn.style.color = 'white';
            closeBtn.style.border = 'none';
            closeBtn.style.padding = '8px 15px';
            closeBtn.style.borderRadius = '5px';
            closeBtn.style.cursor = 'pointer';
            closeBtn.style.fontSize = '0.9rem';
            closeBtn.style.fontWeight = 'bold';
            closeBtn.onclick = () => document.body.removeChild(overlay);
            
            btnContainer.appendChild(closeBtn);
            topBar.appendChild(title);
            topBar.appendChild(btnContainer);

            // Bloqueador de clicks en ciertas esquinas si fuesen necesarias, 
            // pero con la barra superior de 56px ya ocultamos los íconos de GDrive (Popup y More Actions)
            
            container.appendChild(iframe);
            container.appendChild(topBar);

            // Cerrar al clickear fuera del contenedor
            overlay.onclick = (e) => {
                if(e.target === overlay) document.body.removeChild(overlay);
            };

            overlay.appendChild(container);
            document.body.appendChild(overlay);
        }

        async function borrarEvidencia(id) {
            if(!confirm("¿Estás seguro de eliminar este archivo? Se borrará de la BD y de Drive.")) return;
            try {
                const isAdmin = isAdminOrMaster();
                const selectLider = document.getElementById('bitacora-admin-input-uid');
                const uidDestino = isAdmin ? (selectLider?.value || CURRENT_USER.registro) : CURRENT_USER.registro;

                await BO_API.deleteBitacoraEvidencia(id);
                alert("Archivo borrado exitosamente.");
                loadBitacora(uidDestino);
            } catch(e) {
                alert("Error al borrar: " + e.message);
            }
        }

if ('serviceWorker' in navigator) {
            window.addEventListener('load', () => {
                navigator.serviceWorker.register('./sw.js')
                    .then(registration => {
                        console.log('✅ PWA ServiceWorker registrado con éxito:', registration.scope);
                    })
                    .catch(err => {
                        console.log('❌ Fallo al registrar el ServiceWorker:', err);
                    });
            });
        }

/* ═══════════════════════════════════════════════════════════════
       MOBILE LAYOUT ENFORCER — JS-based, bypasses CSS cache totally
       Runs on load + after every view navigation.
       Forces all multi-column grids inside main-content to 1 column
       on screens ≤ 1024px. Only stats-grid keeps 2 cols (≤768px: 1 col)
       ═══════════════════════════════════════════════════════════════ */
    function enforceGridForMobile() {
        if (window.innerWidth > 1024) return; // desktop: do nothing

        const mc = document.getElementById('mainContent');
        if (!mc) return;

        const isTinyScreen = window.innerWidth <= 430;

        // Force all inline grid elements to 1 column
        mc.querySelectorAll('[style*="grid-template-columns"]').forEach(el => {
            el.style.setProperty('grid-template-columns', '1fr', 'important');
        });

        // Stats-grid: keep 2 cols on phones > 380px, 1 col on tiny screens
        mc.querySelectorAll('.stats-grid').forEach(el => {
            const cols = (window.innerWidth <= 380) ? '1fr' : '1fr 1fr';
            el.style.setProperty('grid-template-columns', cols, 'important');
        });

        // Also ensure bo-layout and main-content don't overflow
        const layout = document.querySelector('.bo-layout');
        if (layout) {
            layout.style.setProperty('grid-template-columns', '1fr', 'important');
            layout.style.setProperty('max-width', '100vw', 'important');
            layout.style.setProperty('overflow-x', 'hidden', 'important');
        }
        if (mc) {
            mc.style.setProperty('max-width', '100%', 'important');
            mc.style.setProperty('width', '100%', 'important');
            mc.style.setProperty('min-width', '0', 'important');
            mc.style.setProperty('overflow-x', 'hidden', 'important');
            mc.style.setProperty('box-sizing', 'border-box', 'important');
        }
    }

    // Run on load
    document.addEventListener('DOMContentLoaded', enforceGridForMobile);
    window.addEventListener('resize', enforceGridForMobile);

    // Patch showView so it runs after every navigation too
    document.addEventListener('DOMContentLoaded', () => {
        const origShowView = window.showView;
        if (typeof origShowView === 'function') {
            window.showView = function(viewId) {
                origShowView.call(this, viewId);
                setTimeout(enforceGridForMobile, 50); // after DOM updates
            };
        }
    });

    if (typeof _initCalendarioCorporativo === 'function') {
        window._initCalendarioCorporativo = _initCalendarioCorporativo;
    }


